/* eslint-disable max-len */

'use strict';

const FR = {
	results: {
		caption: '#COUNT# résultats de recherche trouvés pour <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Voir plus de résultats',
		noResultsText: 'Désolés, nous n\'avons trouvé aucun résultat pour votre recherche.',
		queryCorrectionText: 'Est-ce que vous vouliez dire "#CORRECTION#" ?',
		queryCorrectionRewrite: 'Résultats de recherche pour "#CORRECTION#"',
		orderByRelevanceText: 'Pertinence',
		sortingLabel: 'Tri :',
		searchResultsLayerLabel: 'Résultats de recherche',
		watermarkLabel: 'Boosté avec Site Search 360',
		variantsCountLabel: '+#COUNT# autres options disponibles',
		variantsCountLabelSingular: '+1 option supplémentaire disponible',
		queryCorrectionOverride: 'Chercher plutôt "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Recherches connexes :',
		pageDescriptionLabel: '#COUNT# de #TOTAL# résultats affichés',
		copyLinkToPositionButtonLabel: 'Copier un lien vers cette position dans la liste',
		copiedLinkToPositionButtonLabel: 'Lien copié'
	},
	accessibility: {
		searchFieldLabel: 'Requête de recherche',
		srSuggestionsHiddenText: 'Les suggestions de recherche sont masquées',
		srNoSuggestionsText: 'Aucune suggestion de recherche',
		srSuggestionsCountText: '#COUNT# suggestions de recherche affichées',
		srOneSuggestionText: 'Une suggestion de recherche affichée',
		srSuggestBoxControlDescription: 'Utilisez les flèches haut et bas pour sélectionner le résultat disponible. Appuyez sur Entrée pour accéder au résultat de recherche sélectionné. Les utilisateurs d\'appareils tactiles peuvent se servir de gestes tels que toucher et glisser.'
	},
	smart404: {
		caption: 'Essayez plutôt ici :',
		searchResultsLayerLabel: 'Liens recommandés'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Tous les résultats',
			allResultsTabTitle: 'Tous les résultats (#COUNT#)',
			navigationLabel: 'Navigation des résultats de recherche'
		}
	},
	voiceSearch: {
		lang: 'fr-FR'
	},
	filters: {
		label: 'Filtre',
		deleteAllLabel: 'Tout effacer',
		toggleButtonLabel: 'Filtrer les résultats',
		multiSelectSearchLabel: 'Rechercher #FILTER_NAME#',
		multiSelectEmptyState: 'Aucun filtre correspondant',
		multiSelectShowMoreLabel: 'Voir #COUNT# en plus',
		multiSelectShowLessLabel: 'Voir moins d\'options',
		clearGroupLabel: 'Effacer',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Max. #UNIT#',
		submitButtonLabel: 'Envoyer',
		skipFilter: 'Sauter les filtres',
		skipFilterGroup: 'Sauter le groupe de filtres',
		selectedFilterOptionsLabel: 'Options pour le filtre sélectionné',
		dayLabel: 'Jour',
		monthLabel: 'Mois',
		yearLabel: 'Année',
		sliderResultCountLabel: '(#COUNT# résultats)'
	},
	suggestions: {
		searchHistoryLabel: 'Vous avez cherché récemment :',
		groupCta: {
			label: 'Tous les résultats du group #GROUP#'
		},
		viewAllLabel: 'Montrer tous les résultats',
		allResultsName: 'Tous',
		removeSuggestionLabel: 'Supprimer la suggestion',
		submitGroupLabel: 'Montrer tous les résultats de recherche #GROUP_NAME#',
		suggestionsLayerLabel: 'Suggestions de recherche',
		suggestionsNavigationLabel: 'Navigation des groupes de suggestion'
	},
	errorScreen: {
		offline: {
			title: 'Vous êtes hors ligne',
			message: 'Il semble qu\'il y ait un problème avec votre réseau. Veuillez vérifier votre connexion Internet.',
			tryAgain: 'Veuillez réessayer'
		},
		blocked: {
			title: 'Demande de recherche bloquée',
			message: 'Veuillez vérifier vos extensions de protection de la vie privée.',
			tryAgain: 'Veuillez réessayer'
		},
		generic: {
			title: 'Oups !',
			message: 'Quelque chose a malfonctionné. Nous sommes désolés !',
			tryAgain: 'Veuillez réessayer'
		},
		siteId: {
			title: 'ID de site manquante',
			message: 'Merci de vérifier votre code de configuration et assurez-vous de saisir une ID de site valide.',
			tryAgain: 'En savoir plus'
		}
	},
	contentGroups: {
		otherName: 'Autres'
	},
	noResultsPage: {
		title: 'Nous sommes désolés, nous n\'avons pas trouvé de résultats correspondants à votre recherche "#QUERY#"',
		description: 'Merci de bien vouloir essayer un autre terme de recherche ou d\'ajuster votre recherche au cas où il y aurait une faute de frappe que nous n\'aurions pas relevée.',
		fuzzyResults: 'D\'autres résultats que vous pourriez trouver utiles',
		popularResults: 'Quelques-uns de nos contenus populaires',
		popularQueries: 'Autres recherches populaires'
	},
	comparison: {
		buttonLabel: 'Comparer',
		tooManyProductsLabel: 'Seuls les 4 premiers produits seront comparés.',

		heading: 'Comparer les produits',
		showDifferencesLabel: 'Afficher uniquement les différences',
		ctaText: 'Ajouter au panier'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat à propos de #PRODUCT_NAME#' }
};

const DE = {
	results: {
		caption: '#COUNT# Suchergebnisse f&uuml;r <span class="ss360-layer__heading-query">"#QUERY#"</span> gefunden',
		moreResultsButton: 'Weitere ansehen',
		noResultsText: 'Entschuldigung, wir haben keine Treffer auf Deine Suchanfrage gefunden.',
		queryCorrectionText: 'Hast du "#CORRECTION#" gemeint?',
		queryCorrectionRewrite: 'Ergebnisse f&uuml;r "#CORRECTION#" werden angezeigt',
		orderByRelevanceText: 'Relevanz',
		sortingLabel: 'Sortierung:',
		searchResultsLayerLabel: 'Suchergebnisse',
		watermarkLabel: 'Angetrieben von Site Search 360',
		variantsCountLabel: '+#COUNT# weitere Varianten verfügbar',
		variantsCountLabelSingular: '+1 weitere Variante verfügbar',
		queryCorrectionOverride: 'Stattdessen nach "#ORIGINAL_QUERY#" suchen',
		relatedQueriesTitle: 'Ähnliche Suchanfragen:',
		pageDescriptionLabel: '#COUNT# von #TOTAL# Ergebnissen werden angezeigt',
		copyLinkToPositionButtonLabel: 'Link zu dieser Position in der Liste kopieren',
		copiedLinkToPositionButtonLabel: 'Link kopiert'
	},
	accessibility: {
		searchFieldLabel: 'Suchanfrage',
		srSuggestionsHiddenText: 'Suchvorschl&auml;ge sind ausgeblendet',
		srNoSuggestionsText: 'Keine Suchvorschl&auml;ge',
		srSuggestionsCountText: '#COUNT# angezeigte Suchvorschl&auml;ge',
		srOneSuggestionText: 'Ein angezeigter Suchvorschlag',
		srSuggestBoxControlDescription: 'Verwende die Pfeile nach oben und unten, um das verf&uuml;gbare Ergebnis auszuw&auml;hlen. Dr&uuml;cke die Eingabetaste, um zum ausgew&auml;hlten Suchergebnis zu gelangen. Benutzer von Touchger&auml;ten k&ouml;nnen Touch- und Streichgesten verwenden.'
	},
	smart404: {
		caption: 'Versuch stattdessen das:',
		searchResultsLayerLabel: 'Empfohlene Links'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle Ergebnisse',
			allResultsTabTitle: 'Alle Ergebnisse (#COUNT#)',
			navigationLabel: 'Suchergebnis-Navigation'
		}
	},
	voiceSearch: {
		lang: 'de'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Alle zur&uuml;cksetzen',
		toggleButtonLabel: 'Ergebnisse filtern',
		multiSelectSearchLabel: 'Suche #FILTER_NAME#',
		multiSelectEmptyState: 'Keine passenden Filteroptionen.',
		multiSelectShowMoreLabel: '#COUNT# weitere ansehen',
		multiSelectShowLessLabel: 'Weniger Optionen anzeigen',
		clearGroupLabel: 'zur&uuml;cksetzen',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Anwenden',
		skipFilter: 'Filter überspringen',
		skipFilterGroup: 'Filtergruppe überspringen',
		selectedFilterOptionsLabel: 'Ausgewählte Filteroptionen',
		dayLabel: 'Tag',
		monthLabel: 'Monat',
		yearLabel: 'Jahr',
		sliderResultCountLabel: '(#COUNT# Ergebnisse)'
	},
	suggestions: {
		searchHistoryLabel: 'Ihre letzten Suchanfragen:',
		groupCta: {
			label: 'Alle #GROUP# Ergebnisse anzeigen'
		},
		viewAllLabel: 'Alle Ergebnisse anzeigen',
		allResultsName: 'Alle',
		removeSuggestionLabel: 'Suchvorschlag entfernen',
		submitGroupLabel: 'Alle #GROUP_NAME# Suchergebnisse anzeigen',
		suggestionsLayerLabel: 'Suchvorschläge',
		suggestionsNavigationLabel: 'Vorschlag Gruppen Navigation'
	},
	errorScreen: {
		offline: {
			title: 'Sie sind offline',
			message: 'Es scheint ein Problem mit Ihrem Netzwerk zu geben. Bitte &uuml;berpr&uuml;fen Sie Ihre Internetverbindung.',
			tryAgain: 'Erneut versuchen'
		},
		blocked: {
			title: 'Suchanfrage blockiert',
			message: 'Bitte &uuml;berpr&uuml;fen Sie Ihre Datenschutzerweiterungen.',
			tryAgain: 'Erneut versuchen'
		},
		generic: {
			title: 'Hoppla!',
			message: 'Etwas ging schief. Das tut uns sehr leid!',
			tryAgain: 'Erneut versuchen'
		},
		siteId: {
			title: 'Site-ID fehlt',
			message: 'Bitte &uuml;berpr&uuml;fen Sie Ihren Konfigurationscode und stellen Sie sicher, dass Sie eine g&uuml;ltige Site-ID angeben.',
			tryAgain: 'Mehr Informationen'
		}
	},
	contentGroups: {
		otherName: 'Weiteres'
	},
	noResultsPage: {
		title: 'Es tut uns leid, wir konnten keine genaue Übereinstimmung für "#QUERY#" finden',
		description: 'Bitte versuchen Sie einen anderen Suchbegriff oder passen Sie Ihre Anfrage an, falls wir einen Tippfehler übersehen haben.',
		fuzzyResults: 'Andere Ergebnisse, die Sie nützlich finden könnten',
		popularResults: 'Einige unserer beliebten Inhalte',
		popularQueries: 'Andere beliebte Suchanfragen'
	},
	comparison: {
		buttonLabel: 'Vergleichen',
		tooManyProductsLabel: 'Nur die ersten 4 Produkte werden verglichen.',

		heading: 'Produkte vergleichen',
		showDifferencesLabel: 'Nur Unterschiede anzeigen',
		ctaText: 'In den Warenkorb'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat über #PRODUCT_NAME#' }
};

const NL = {
	results: {
		caption: 'Gevonden #COUNT# zoekresultaten voor <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Meer bekijken',
		noResultsText: 'Sorry, we hebben geen matches voor je zoekopdracht gevonden.',
		queryCorrectionText: 'Bedoelde je "#CORRECTION#"?',
		queryCorrectionRewrite: 'Getoonde resultaten voor "#CORRECTION#"',
		orderByRelevanceText: 'Relevantie',
		sortingLabel: 'Gesorteerd naar:',
		searchResultsLayerLabel: 'Zoekresultaten',
		watermarkLabel: 'Aangedreven door Site Search 360',
		variantsCountLabel: '+#COUNT# meer opties beschikbaar',
		variantsCountLabelSingular: '+1 extra optie beschikbaar',
		queryCorrectionOverride: 'Zoek in plaats daarvan naar "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Gerelateerde zoekopdrachten:',
		pageDescriptionLabel: 'Tonen van #COUNT# van #TOTAL# resultaten',
		copyLinkToPositionButtonLabel: 'Kopieer een link naar deze positie in de lijst',
		copiedLinkToPositionButtonLabel: 'Gekopieerde link'
	},
	accessibility: {
		searchFieldLabel: 'Start zoekopdracht',
		srSuggestionsHiddenText: 'Zoeksuggesties zijn verborgen',
		srNoSuggestionsText: 'Geen zoeksuggesties',
		srSuggestionsCountText: '#COUNT# getoonde zoeksuggesties',
		srOneSuggestionText: 'Één getoonde zoeksuggestie',
		srSuggestBoxControlDescription: 'Gebruik de pijltjes op en neer om een beschikbaar resultaat te selecteren. Druk op Enter om naar het geselecteerde zoekresultaat te gaan. Als u met aanraaktoetsen werkt, kunt u touch- en swipetekens gebruiken.'
	},
	smart404: {
		caption: 'Probeer als alternatief deze link:',
		searchResultsLayerLabel: 'Aanbevolen koppelingen'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle resultaten',
			allResultsTabTitle: 'Alle resultaten (#COUNT#)',
			navigationLabel: 'Navigatie zoekresultaten'
		}
	},
	voiceSearch: {
		lang: 'nl-NL'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Alles resetten',
		toggleButtonLabel: 'Filterresultaten',
		multiSelectSearchLabel: 'Zoeken #FILTER_NAME#',
		multiSelectEmptyState: 'Geen overeenkomende filteropties.',
		multiSelectShowMoreLabel: 'Zie #COUNT# meer',
		multiSelectShowLessLabel: 'Zie minder opties',
		clearGroupLabel: 'wissen',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Max. #UNIT#',
		submitButtonLabel: 'Instellen',
		skipFilter: 'Filters overslaan',
		skipFilterGroup: 'Filtergroep overslaan',
		selectedFilterOptionsLabel: 'Geselecteerde filteropties',
		dayLabel: 'Dag',
		monthLabel: 'Maand',
		yearLabel: 'Jaar',
		sliderResultCountLabel: '(#COUNT# resultaten)'
	},
	suggestions: {
		searchHistoryLabel: 'Je hebt onlangs gezocht naar:',
		groupCta: {
			label: 'Zie alle #GROUP# resultaten'
		},
		viewAllLabel: 'Toon alle resultaten',
		allResultsName: 'Alle',
		removeSuggestionLabel: 'Verwijder suggestie',
		submitGroupLabel: 'Toon alle zoekresultaten van #GROUP_NAME#',
		suggestionsLayerLabel: 'Suggesties zoeken',
		suggestionsNavigationLabel: 'Suggestie Groepen Navigatie'
	},
	errorScreen: {
		offline: {
			title: 'U bent offline',
			message: 'Het lijkt erop dat er een probleem is met je netwerk. Controleer uw internetverbinding.',
			tryAgain: 'Probeer het nog eens'
		},
		blocked: {
			title: 'Zoekopdracht geblokkeerd',
			message: 'Controleer uw privacy-uitbreidingen.',
			tryAgain: 'Probeer het nog eens'
		},
		generic: {
			title: 'Oeps!',
			message: 'Er is iets misgegaan. Dat spijt ons!',
			tryAgain: 'Probeer het nog eens'
		},
		siteId: {
			title: 'Site ID ontbreekt',
			message: 'Controleer uw configuratiecode en zorg voor een geldige site ID.',
			tryAgain: 'Meer informatie'
		}
	},
	contentGroups: {
		otherName: 'Anders'
	},
	noResultsPage: {
		title: 'Het spijt ons, we konden geen exacte overeenkomst vinden voor "#QUERY#".',
		description: 'Probeer alstublieft een andere zoekterm of pas uw zoekopdracht aan voor het geval er een typo is die we niet hebben gevonden.',
		fuzzyResults: 'Andere resultaten die u misschien nuttig vindt',
		popularResults: 'Enkele van onze populaire inhoud',
		popularQueries: 'Mensen zoeken vaak naar'
	},
	comparison: {
		buttonLabel: 'Vergelijken',
		tooManyProductsLabel: 'Alleen de eerste 4 producten worden vergeleken.',

		heading: 'Producten vergelijken',
		showDifferencesLabel: 'Toon alleen verschillen',
		ctaText: 'Toevoegen aan winkelwagen'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat over #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Zie alle',
};

const PL = {
	results: {
		caption: 'Znaleziono #COUNT# wyników wyszukiwania dla <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Zobacz więcej',
		noResultsText: 'Przepraszamy, nie znaleźliśmy żadnych dopasowań do twojego zapytania.',
		queryCorrectionText: 'Czy masz na myśli „#CORRECTION#”?',
		queryCorrectionRewrite: 'Prezentuję wyniki dla „#CORRECTION#”',
		orderByRelevanceText: 'Znaczenie',
		sortingLabel: 'Sortowanie:',
		searchResultsLayerLabel: 'Wyniki wyszukiwania',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# dalsze dostępne opcje',
		variantsCountLabelSingular: 'Dostępna jeszcze +1 opcja',
		queryCorrectionOverride: 'Zamiast tego szukaj "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Powiązane wyszukiwania:',
		pageDescriptionLabel: 'Wyświetlanie #COUNT# z #TOTAL# wyników',
		copyLinkToPositionButtonLabel: 'Skopiuj link do tej pozycji na liście',
		copiedLinkToPositionButtonLabel: 'Skopiowany link'
	},
	accessibility: {
		searchFieldLabel: 'Fraza zapytania',
		srSuggestionsHiddenText: 'Sugestie wyszukiwania są ukryte',
		srNoSuggestionsText: 'Brak sugestii wyszukiwania',
		srSuggestionsCountText: 'Pokazano #COUNT# sugestii wyszukiwania',
		srOneSuggestionText: 'Pokazano jedną sugestię wyszukiwania',
		srSuggestBoxControlDescription: 'Użyj strzałek w górę i w dół, aby wybrać dostępny wynik. Naciśnij Enter, aby przejść do wybranego wyniku wyszukiwania. Użytkownicy urządzeń dotykowych mogą korzystać z gestów dotykowych i gestów przeciągania.'
	},
	smart404: {
		caption: 'Spróbuj tutaj zamiast tego:',
		searchResultsLayerLabel: 'Polecane Linki'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Wszystkie wyniki',
			allResultsTabTitle: 'Wszystkie wyniki (#COUNT#)',
			navigationLabel: 'Nawigacja po wynikach wyszukiwania'
		}
	},
	voiceSearch: {
		lang: 'pl'
	},
	filters: {
		label: 'Filtr',
		deleteAllLabel: 'Zresetuj wszystkie',
		toggleButtonLabel: 'Wyniki filtrowania',
		multiSelectSearchLabel: 'Szukaj #FILTER_NAME#',
		multiSelectEmptyState: 'Brak pasujących opcji filtrowania.',
		multiSelectShowMoreLabel: 'Zobacz #COUNT# więcej',
		multiSelectShowLessLabel: 'Zobacz mniej opcji',
		clearGroupLabel: 'oczyść',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Maks. #UNIT#',
		submitButtonLabel: 'Ustaw',
		skipFilter: 'Pomiń filtry',
		skipFilterGroup: 'Pomiń grupę filtrów',
		selectedFilterOptionsLabel: 'Wybrane opcje filtra',
		dayLabel: 'Dzień',
		monthLabel: 'Miesiąc',
		yearLabel: 'Rok',
		sliderResultCountLabel: '(#COUNT# wyników)'
	},
	suggestions: {
		searchHistoryLabel: 'Aktualnie szukasz:',
		groupCta: {
			label: 'Zobacz wszystkie wyniki (#GROUP#)'
		},
		viewAllLabel: 'Pokaż wszystkie wyniki',
		allResultsName: 'Wszystkie',
		removeSuggestionLabel: 'Usuń sugestię',
		submitGroupLabel: 'Pokaż wszystkie wyniki wyszukiwania #GROUP_NAME#',
		suggestionsLayerLabel: 'Szukaj Sugestie',
		suggestionsNavigationLabel: 'Grupy sugestii Nawigacja'
	},
	errorScreen: {
		offline: {
			title: 'Jesteś offline',
			message: 'Wygląda na to, że jest problem z twoją siecią. Proszę sprawdzić połączenie z Internetem.',
			tryAgain: 'Spróbuj ponownie'
		},
		blocked: {
			title: 'Zlecenie wyszukiwania zablokowane',
			message: 'Proszę sprawdzić swoje rozszerzenia prywatności.',
			tryAgain: 'Spróbuj ponownie'
		},
		generic: {
			title: 'Oops!',
			message: 'Coś poszło nie tak. Przykro nam z tego powodu!',
			tryAgain: 'Spróbuj ponownie'
		},
		siteId: {
			title: 'Brak identyfikatora strony',
			message: 'Sprawdź swój kod konfiguracyjny i upewnij się, że podałeś prawidłowy identyfikator strony.',
			tryAgain: 'Dowiedz się więcej'
		}
	},
	contentGroups: {
		otherName: 'Inne'
	},
	noResultsPage: {
		title: 'Przepraszamy, nie udało nam się znaleźć dokładnego dopasowania dla "#QUERY#".',
		description: 'Proszę spróbować innego hasła wyszukiwania lub dostosować zapytanie w przypadku, gdy jest literówka, której nie wychwyciliśmy',
		fuzzyResults: 'Inne wyniki, które mogą Ci się przydać',
		popularResults: 'Niektóre z naszych popularnych treści',
		popularQueries: 'Ludzie często szukają'
	},
	comparison: {
		buttonLabel: 'Porównaj',
		tooManyProductsLabel: 'Porównane będą tylko pierwsze 4 produkty.',

		heading: 'Porównanie produktów',
		showDifferencesLabel: 'Pokaż tylko różnice',
		ctaText: 'Dodaj do koszyka'
	},
	zoe: { chatLabel: 'Czat', title: 'Czat o #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Pokaż wszystkie'
};

const PT = {
	results: {
		caption: 'Encontrados #COUNT# resultados de pesquisa para <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Ver mais',
		noResultsText: 'Desculpe, não encontramos resultados para a sua busca.',
		queryCorrectionText: 'Quis dizer "#CORRECTION#"?',
		queryCorrectionRewrite: 'Mostrando resultados para "#CORRECTION#"',
		orderByRelevanceText: 'Relevância',
		sortingLabel: 'Classificação:',
		searchResultsLayerLabel: 'Resultados da pesquisa',
		watermarkLabel: 'Movido por Site Search 360',
		variantsCountLabel: '+#COUNT# mais opções disponíveis',
		variantsCountLabelSingular: '+1 mais opção disponível',
		queryCorrectionOverride: 'Pesquisar por "#ORIGINAL_QUERY#" em vez de',
		relatedQueriesTitle: 'Pesquisas relacionadas:',
		pageDescriptionLabel: 'Mostrando #COUNT# de #TOTAL# resultados',
		copyLinkToPositionButtonLabel: 'Copiar uma ligação para esta posição na lista',
		copiedLinkToPositionButtonLabel: 'Ligação copiada'
	},
	accessibility: {
		searchFieldLabel: 'Consulta de pesquisa',
		srSuggestionsHiddenText: 'As sugestões de pesquisa estão ocultas',
		srNoSuggestionsText: 'Nenhuma sugestão de pesquisa',
		srSuggestionsCountText: '#COUNT# sugestões de pesquisa exibidas',
		srOneSuggestionText: 'Uma sugestão de pesquisa exibida',
		srSuggestBoxControlDescription: 'Use as setas para cima e para baixo para selecionar o resultado disponível. Prima Enter para ir para o resultado de pesquisa selecionado. Os utilizadores de dispositivos tácteis podem usar gestos de toque e deslize.'
	},
	smart404: {
		caption: 'Em vez disso, tente isto:',
		searchResultsLayerLabel: 'Ligações recomendadas'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Todos os resultados',
			allResultsTabTitle: 'Todos os resultados (#COUNT#)',
			navigationLabel: 'Navegação dos resultados da pesquisa'
		}
	},
	voiceSearch: {
		lang: 'pt-PT'
	},
	filters: {
		label: 'Filtrar',
		deleteAllLabel: 'Redefinir tudo',
		toggleButtonLabel: 'Filtrar resultados',
		multiSelectSearchLabel: 'Procurar #FILTER_NAME#',
		multiSelectEmptyState: 'Nenhuma opção de filtro correspondente.',
		multiSelectShowMoreLabel: 'Ver #COUNT# mais',
		multiSelectShowLessLabel: 'Ver menos opções',
		clearGroupLabel: 'limpar',
		sliderMinUnitLabel: 'Mín. #UNIT#',
		sliderMaxUnitLabel: 'Máx. #UNIT#',
		submitButtonLabel: 'Definir',
		skipFilter: 'Saltar Filtros',
		skipFilterGroup: 'Pular grupo de filtros',
		selectedFilterOptionsLabel: 'Opções de filtro seleccionadas',
		dayLabel: 'Dia',
		monthLabel: 'Mês',
		yearLabel: 'Ano',
		sliderResultCountLabel: '(#COUNT# resultados)'
	},
	suggestions: {
		searchHistoryLabel: 'Pesquisou recentemente sobre:',
		groupCta: {
			label: 'Ver todos os resultados para #GROUP#'
		},
		viewAllLabel: 'Mostrar todos os resultados',
		allResultsName: 'Todos',
		removeSuggestionLabel: 'Remover sugestão',
		submitGroupLabel: 'Mostrar todos #GROUP_NAME# resultados da pesquisa',
		suggestionsLayerLabel: 'Sugestões de Pesquisa',
		suggestionsNavigationLabel: 'Navegação de Grupos de Sugestões'
	},
	errorScreen: {
		offline: {
			title: 'Está offline',
			message: 'Parece haver um problema com a sua rede. Por favor, verifique a sua ligação à Internet.',
			tryAgain: 'Tente novamente'
		},
		blocked: {
			title: 'Pedido de pesquisa bloqueado',
			message: 'Por favor, verifique as suas extensões de privacidade.',
			tryAgain: 'Tente novamente'
		},
		generic: {
			title: 'Oops!',
			message: 'Alguma coisa correu mal. Desculpa lá!',
			tryAgain: 'Tente novamente'
		},
		siteId: {
			title: 'Falta o ID do sítio',
			message: 'Por favor, verifique o seu código de configuração e certifique-se de fornecer uma identificação de sítio vàlida.',
			tryAgain: 'Mais informação'
		}
	},
	contentGroups: {
		otherName: 'Outros'
	},
	noResultsPage: {
		title: 'Lamentamos, não conseguimos encontrar uma correspondência exata para "#QUERY#".',
		description: 'Por favor tente outro termo de pesquisa ou ajuste a sua consulta no caso de haver uma gralha que não tenhamos capturado.',
		fuzzyResults: 'Outros resultados que lhe poderão ser úteis',
		popularResults: 'Alguns dos nossos conteúdos favoritos',
		popularQueries: 'As pessoas procuram frequentemente'
	},
	comparison: {
		buttonLabel: 'Comparar',
		tooManyProductsLabel: 'Apenas os primeiros 4 produtos serão comparados.',

		heading: 'Comparar Produtos',
		showDifferencesLabel: 'Mostrar apenas as diferenças',
		ctaText: 'Adicionar ao carrinho'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat sobre #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Ver todos',
};

const TR = {
	results: {
		caption: 'Bulunan #COUNT#  arama sonuçları <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Daha fazla göster',
		noResultsText: 'Üzgünüz, sorgunuz için herhangi bir eşleşme bulamadık.',
		queryCorrectionText: 'Şunu mu demek istediniz "#CORRECTION#"?',
		queryCorrectionRewrite: '"#CORRECTION#" ile ilgili sonuçlar',
		orderByRelevanceText: 'Uygunluk',
		sortingLabel: 'Sıralama:',
		searchResultsLayerLabel: 'Arama Sonuçları',
		watermarkLabel: 'Tarafından desteklenmektedir Site Search 360',
		variantsCountLabel: '+#COUNT# seçenek',
		variantsCountLabelSingular: '+1 ek seçenek mevcut',
		queryCorrectionOverride: 'Bunun yerine "#ORIGINAL_QUERY#"i arayın',
		relatedQueriesTitle: 'Ilgili aramalar:',
		pageDescriptionLabel: '#TOTAL# sonuçların #COUNT# gösteriliyor',
		copyLinkToPositionButtonLabel: 'Listedeki bu pozisyona bir bağlantı kopyalayın',
		copiedLinkToPositionButtonLabel: 'Bağlantı kopyalandı'
	},
	accessibility: {
		searchFieldLabel: 'Arama sorgusu',
		srSuggestionsHiddenText: 'Arama önerileri gizlendi',
		srNoSuggestionsText: 'Arama önerisi yok',
		srSuggestionsCountText: '#COUNT# gösterilen arama önerileri',
		srOneSuggestionText: 'Bir arama önerisi gösteriliyor',
		srSuggestBoxControlDescription: 'Mevcut sonucu seçmek için yukarı ve aşağı okları kullanın. Seçili arama sonucuna gitmek için Enter tuşuna basın. Dokunmatik cihaz kullanıcıları, dokunma ve kaydırma hareketlerini kullanabilir.'
	},
	smart404: {
		caption: 'Bunun yerine buraya gitmeyi deneyin:',
		searchResultsLayerLabel: 'Önerilen Bağlantılar'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Tüm sonuçlar',
			allResultsTabTitle: 'Tüm sonuçlar (#COUNT#)',
			navigationLabel: 'Arama Sonucunda Gezinme'
		}
	},
	voiceSearch: {
		lang: 'tr-TR'
	},
	filters: {
		label: 'Filtrele',
		deleteAllLabel: 'Hepsini sıfırla',
		toggleButtonLabel: 'Sonuçları filtrele',
		multiSelectSearchLabel: 'Ara #FILTER_NAME#',
		multiSelectEmptyState: 'Eşleşen filtre seçeneği yok.',
		multiSelectShowMoreLabel: 'Daha #COUNT# fazla göster',
		multiSelectShowLessLabel: 'Daha az seçenek göster',
		clearGroupLabel: 'temizle',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Maks. #UNIT#',
		submitButtonLabel: 'Ayarla',
		skipFilter: 'Filtreleri Atla',
		skipFilterGroup: 'Filtre Grubunu Atla',
		selectedFilterOptionsLabel: 'Seçilen Filtre Seçenekleri',
		dayLabel: 'Gün',
		monthLabel: 'Ay',
		yearLabel: 'Yıl',
		sliderResultCountLabel: '(#COUNT# sonuçlar)'
	},
	suggestions: {
		searchHistoryLabel: 'Yakın zamanda şunları aradınız:',
		groupCta: {
			label: 'Tüm sonuçlar #GROUP# göster'
		},
		viewAllLabel: 'Tüm sonuçları göster',
		allResultsName: 'Tüm',
		removeSuggestionLabel: 'Öneriyi kaldır',
		submitGroupLabel: 'Tüm #GROUP_NAME# arama sonuçlarını göster',
		suggestionsLayerLabel: 'Arama Önerileri',
		suggestionsNavigationLabel: 'Öneri Gruplarında Gezinme'
	},
	errorScreen: {
		offline: {
			title: 'Çevrimdışısınız',
			message: 'Ağınızda bir sorun var gibi görünüyor. Lütfen internet bağlantınızı kontrol edin.',
			tryAgain: 'Tekrar deneyin'
		},
		blocked: {
			title: 'Arama isteği engellendi',
			message: 'Lütfen gizlilik uzantılarınızı kontrol edin.',
			tryAgain: 'Tekrar deneyin'
		},
		generic: {
			title: 'Oops!',
			message: 'Bir şeyler yanlış gitti. Bunun için üzgünüm!',
			tryAgain: 'Tekrar deneyin'
		},
		siteId: {
			title: 'Site kimliği eksik',
			message: 'Lütfen yapılandırma kodunuzu kontrol edin ve geçerli bir site kimliği sağladığınızdan emin olun.',
			tryAgain: 'Daha fazla bilgi edin'
		}
	},
	contentGroups: {
		otherName: 'Diğer'
	},
	noResultsPage: {
		title: 'Üzgünüz, "#QUERY#" için tam bir eşleşme bulamadık',
		description: 'Lütfen başka bir arama terimi deneyin veya yakalayamadığımız bir yazım hatası olması durumunda sorgunuzu ayarlayın.',
		fuzzyResults: 'Yararlı bulabileceğiniz diğer sonuçlar',
		popularResults: 'Popüler içeriklerimizden bazıları',
		popularQueries: 'İnsanlar genellikle'
	},
	comparison: {
		buttonLabel: 'Karşılaştır',
		tooManyProductsLabel: 'Sadece ilk 4 ürün karşılaştırılacaktır.',

		heading: 'Ürünleri Karşılaştır',
		showDifferencesLabel: 'Sadece farklılıkları göster',
		ctaText: 'Sepete Ekle'
	},
	zoe: { chatLabel: 'Sohbet', title: '#PRODUCT_NAME# hakkında sohbet' }
	// hiddenViewAllLabel: 'Tümünü göster'
};

const ES = {
	results: {
		caption: 'Se han encontrado #COUNT# resultados de búsqueda para <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Más información',
		noResultsText: 'Lo siento, no hemos encontrado ningún resultado para tu consulta.',
		queryCorrectionText: '¿Querías decir "#CORRECTION#"?',
		queryCorrectionRewrite: 'Mostrando resultados de "#CORRECTION#"',
		orderByRelevanceText: 'Relevancia',
		sortingLabel: 'Clasificación:',
		searchResultsLayerLabel: 'Resultados de la búsqueda',
		watermarkLabel: 'Desarrollado por Site Search 360',
		variantsCountLabel: '+#COUNT# más opciones disponibles',
		variantsCountLabelSingular: '+1 opción más disponible',
		queryCorrectionOverride: 'Busque "#ORIGINAL_QUERY#" en su lugar',
		relatedQueriesTitle: 'Búsquedas relacionadas:',
		pageDescriptionLabel: 'Mostrando #COUNT# de #TOTAL# resultados',
		copyLinkToPositionButtonLabel: 'Copie un enlace a esta posición en la lista',
		copiedLinkToPositionButtonLabel: 'Enlace copiado'
	},
	accessibility: {
		searchFieldLabel: 'Consulta de búsqueda',
		srSuggestionsHiddenText: 'Las sugerencias de búsqueda están ocultas',
		srNoSuggestionsText: 'No hay sugerencias de búsqueda',
		srSuggestionsCountText: '#COUNT# sugerencias de búsqueda mostradas',
		srOneSuggestionText: 'Una sugerencia de búsqueda mostrada',
		srSuggestBoxControlDescription: 'Usa las fechas hacia arriba y abajo para seleccionar los resultados disponibles. Pulsa intro para ir al resultado de búsqueda seleccionado. Los usuarios de dispositivos táctiles pueden usar los gestos de tocar y arrastrar.'
	},
	smart404: {
		caption: 'Intenta desde aquí:',
		searchResultsLayerLabel: 'Enlaces recomendados'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Todos los resultados',
			allResultsTabTitle: 'Todos los resultados (#COUNT#)',
			navigationLabel: 'Navegación por los resultados de la búsqueda'
		}
	},
	voiceSearch: {
		lang: 'es-ES'
	},
	filters: {
		label: 'Filtrar',
		deleteAllLabel: 'Reiniciar todo',
		toggleButtonLabel: 'Filtrar los resultados',
		multiSelectSearchLabel: 'Buscar #FILTER_NAME#',
		multiSelectEmptyState: 'No hay opciones de filtración compatibles.',
		multiSelectShowMoreLabel: 'Ver #COUNT# más',
		multiSelectShowLessLabel: 'Ver más opciones',
		clearGroupLabel: 'eliminar',
		sliderMinUnitLabel: '#UNIT# mín.',
		sliderMaxUnitLabel: '#UNIT# máx.',
		submitButtonLabel: 'Fijar',
		skipFilter: 'Omitir filtros',
		skipFilterGroup: 'Omitir grupo de filtros',
		selectedFilterOptionsLabel: 'Opciones de filtro seleccionadas',
		dayLabel: 'Día',
		monthLabel: 'Mes',
		yearLabel: 'Año',
		sliderResultCountLabel: '(#COUNT# resultados)'
	},
	suggestions: {
		searchHistoryLabel: 'Ha buscado últimamente:',
		groupCta: {
			label: 'Ver todos los resultados #GROUP#'
		},
		viewAllLabel: 'Mostrar todos los resultados',
		allResultsName: 'Todos',
		removeSuggestionLabel: 'Eliminar sugerencia',
		submitGroupLabel: 'Mostrar todos los resultados de la búsqueda de #GROUP_NAME#',
		suggestionsLayerLabel: 'Buscar sugerencias',
		suggestionsNavigationLabel: 'Sugerencia Grupos Navegación'
	},
	errorScreen: {
		offline: {
			title: 'Está desconectado',
			message: 'Parece que hay un problema con su red. Por favor, compruebe su conexión a Internet.',
			tryAgain: 'Inténtelo de nuevo'
		},
		blocked: {
			title: 'Solicitud de búsqueda bloqueada',
			message: 'Por favor, compruebe sus extensiones de privacidad.',
			tryAgain: 'Inténtelo de nuevo'
		},
		generic: {
			title: '¡Uy!',
			message: 'Algo salió mal. ¡Lo siento!',
			tryAgain: 'Inténtelo de nuevo'
		},
		siteId: {
			title: 'Falta el ID del sitio',
			message: 'Por favor, compruebe su código de configuración y asegúrese de proporcionar una identificación vàlida del sitio.',
			tryAgain: 'Aprenda más'
		}
	},
	contentGroups: {
		otherName: 'Otro'
	},
	noResultsPage: {
		title: 'Lo sentimos, no pudimos encontrar una coincidencia exacta para "#QUERY#"',
		description: 'Por favor, prueba con otro término de búsqueda o ajusta tu consulta en caso de que haya algún error tipográfico que no hayamos detectado.',
		fuzzyResults: 'Otros resultados que pueden resultarle útiles',
		popularResults: 'Algunos de nuestros contenidos más populares',
		popularQueries: 'Otros contenidos populares'
	},
	comparison: {
		buttonLabel: 'Comparar',
		tooManyProductsLabel: 'Solo se compararán los primeros 4 productos.',

		heading: 'Comparar productos',
		showDifferencesLabel: 'Mostrar solo diferencias',
		ctaText: 'Añadir al carrito'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat sobre #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Ver todo'
};

const ES_MX = {
	results: {
		caption: 'Se han encontrado #COUNT# resultados de búsqueda para "#QUERY#',
		moreResultsButton: 'Más información',
		noResultsText: 'Lo siento, no hemos encontrado ningún resultado para tu consulta.',
		queryCorrectionText: '¿Quería decir "#CORRECTION#"?',
		queryCorrectionRewrite: 'Mostrando resultados de "#CORRECTION#"',
		orderByRelevanceText: 'Relevancia',
		sortingLabel: 'Clasificación:',
		searchResultsLayerLabel: 'Resultados de la búsqueda',
		watermarkLabel: 'Desarrollado por Site Search 360',
		variantsCountLabel: '+#COUNT# más opciones disponibles',
		variantsCountLabelSingular: '+1 opción más disponible',
		queryCorrectionOverride: 'Busque "#ORIGINAL_QUERY#" en su lugar',
		relatedQueriesTitle: 'Búsquedas relacionadas:',
		pageDescriptionLabel: 'Mostrando #COUNT# de #TOTAL# resultados',
		copyLinkToPositionButtonLabel: 'Copie un enlace a esta posición en la lista',
		copiedLinkToPositionButtonLabel: 'Enlace copiado',
		sliderResultCountLabel: '(#COUNT# resultados)'
	},
	accessibility: {
		searchFieldLabel: 'Consulta de búsqueda',
		srSuggestionsHiddenText: 'Las sugerencias de búsqueda están ocultas',
		srNoSuggestionsText: 'No hay sugerencias de búsqueda',
		srSuggestionsCountText: '#COUNT# sugerencias de búsqueda mostradas',
		srOneSuggestionText: 'Una sugerencia de búsqueda mostrada',
		srSuggestBoxControlDescription: 'Use las fechas hacia arriba y abajo para seleccionar los resultados disponibles. Pulse intro para ir al resultado de búsqueda seleccionado. Los usuarios de dispositivos táctiles pueden usar los gestos de tocar y arrastrar.'
	},
	smart404: {
		caption: 'Intente desde aquí:',
		searchResultsLayerLabel: 'Enlaces recomendados'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Todos los resultados',
			allResultsTabTitle: 'Todos los resultados (#COUNT#)',
			navigationLabel: 'Navegación por los resultados de la búsqueda'
		}
	},
	voiceSearch: {
		lang: 'es-MX'
	},
	filters: {
		label: 'Filtrar',
		deleteAllLabel: 'Resetear todo',
		toggleButtonLabel: 'Filtrar los resultados',
		multiSelectSearchLabel: 'Buscar #FILTER_NAME#',
		multiSelectEmptyState: 'No hay opciones de filtración compatibles.',
		multiSelectShowMoreLabel: 'Ver #COUNT# más',
		multiSelectShowLessLabel: 'Ver más opciones',
		clearGroupLabel: 'limpiar',
		sliderMinUnitLabel: '#UNIT# mín.',
		sliderMaxUnitLabel: '#UNIT# máx.',
		submitButtonLabel: 'Fijar',
		skipFilter: 'Omitir filtros',
		skipFilterGroup: 'Omitir grupo de filtros',
		selectedFilterOptionsLabel: 'Opciones de filtro seleccionadas',
		dayLabel: 'Día',
		monthLabel: 'Mes',
		yearLabel: 'Año'
	},
	suggestions: {
		searchHistoryLabel: 'Hace poco ha buscado:',
		groupCta: {
			label: 'Ver todos los resultados #GROUP#'
		},
		viewAllLabel: 'Mostrar todos los resultados',
		allResultsName: 'Todos',
		removeSuggestionLabel: 'Eliminar sugerencia',
		submitGroupLabel: 'Mostrar todos los resultados de la búsqueda de #GROUP_NAME#',
		suggestionsLayerLabel: 'Buscar sugerencias',
		suggestionsNavigationLabel: 'Sugerencia Grupos Navegación'
	},
	errorScreen: {
		offline: {
			title: 'Ud está desconectado',
			message: 'Parece que hay un problema con su red. Por favor, compruebe su conexión a Internet.',
			tryAgain: 'Inténtelo de nuevo'
		},
		blocked: {
			title: 'Solicitud de búsqueda bloqueada',
			message: 'Por favor, compruebe sus extensiones de privacidad.',
			tryAgain: 'Inténtelo de nuevo'
		},
		generic: {
			title: '¡Ups!',
			message: 'Algo salió mal. ¡Lo sentimos mucho!',
			tryAgain: 'Inténtelo de nuevo'
		},
		siteId: {
			title: 'Falta el ID del sitio',
			message: 'Por favor, compruebe su código de configuración y asegúrese de proporcionar una identificación válida del sitio.',
			tryAgain: 'Aprenda más'
		}
	},
	contentGroups: {
		otherName: 'Otro'
	},
	noResultsPage: {
		title: 'Lo sentimos, no se encontraron coincidencias exactas para "#QUERY#"',
		description: 'Por favor, prueba con otro término de búsqueda o ajusta tu consulta en caso de que haya algún error tipográfico que no hayamos detectado.',
		fuzzyResults: 'Otros resultados que pueden resultarle útiles',
		popularResults: 'Algunos de nuestros contenidos más populares',
		popularQueries: 'Otros contenidos populares'
	},
	comparison: {
		buttonLabel: 'Comparar',
		tooManyProductsLabel: 'Solo se compararán los primeros 4 productos.',

		heading: 'Comparar productos',
		showDifferencesLabel: 'Mostrar solo diferencias',
		ctaText: 'Agregar al carrito'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat sobre #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Ver todo'
};

const IT = {
	results: {
		caption: 'Trovati #COUNT# risultati di ricerca per <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Vedi di più',
		noResultsText: 'Mi dispiace, non abbiamo trovato alcuna coincidenza per la tua query.',
		queryCorrectionText: 'Intendevi "#CORRECTION#"?',
		queryCorrectionRewrite: 'Mostrare risultati per "#CORRECTION#"',
		orderByRelevanceText: 'Attinenza',
		sortingLabel: 'Classificazione:',
		searchResultsLayerLabel: 'Risultati della ricerca',
		watermarkLabel: 'Alimentato da Site Search 360',
		variantsCountLabel: '+#COUNT# altre opzioni disponibili',
		variantsCountLabelSingular: '+1 ulteriore opzione disponibile',
		queryCorrectionOverride: 'Cercate invece "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Ricerche collegate:',
		pageDescriptionLabel: 'Visualizzazione di #COUNT# di #TOTAL# risultati',
		copyLinkToPositionButtonLabel: "Copia un collegamento a questa posizione nell'elenco",
		copiedLinkToPositionButtonLabel: 'Collegamento copiato'
	},
	accessibility: {
		searchFieldLabel: 'Query di ricerca',
		srSuggestionsHiddenText: 'I suggerimenti di ricerca sono nascosti',
		srNoSuggestionsText: 'Nessun suggerimento di ricerca',
		srSuggestionsCountText: '#COUNT# suggerimenti di ricerca mostrati',
		srOneSuggestionText: 'Un suggerimento di ricerca mostrato',
		srSuggestBoxControlDescription: 'Utilizza le frecce verso l’alto e verso il basso per selezionare i risultati disponibili. Premi invio per passare al risultato di ricerca selezionato Gli utenti dei dispositivi touch possono ricorrere al tocco e allo scorrimento.'
	},
	smart404: {
		caption: 'Prova invece ad andare qui:',
		searchResultsLayerLabel: 'Link raccomandati'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Tutti i risultati',
			allResultsTabTitle: 'Tutti i risultati (#COUNT#)',
			navigationLabel: 'Navigazione dei risultati della ricerca'
		}
	},
	voiceSearch: {
		lang: 'it-IT'
	},
	filters: {
		label: 'Filtra',
		deleteAllLabel: 'Resetta tutto',
		toggleButtonLabel: 'Filtra risultati',
		multiSelectSearchLabel: 'Cerca #FILTER_NAME#',
		multiSelectEmptyState: 'Nessuna opzione filtro corrispondente.',
		multiSelectShowMoreLabel: 'Vedi altri #COUNT#',
		multiSelectShowLessLabel: 'Vedi meno opzioni',
		clearGroupLabel: 'cancella',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Max. #UNIT#',
		submitButtonLabel: 'Imposta',
		skipFilter: 'Salta Filtri',
		skipFilterGroup: 'Salta gruppo di filtri',
		selectedFilterOptionsLabel: 'Opzioni di filtro selezionate',
		dayLabel: 'Giorno',
		monthLabel: 'Mese',
		yearLabel: 'Anno',
		sliderResultCountLabel: '(#COUNT# risultati)'
	},
	suggestions: {
		searchHistoryLabel: 'Di recente hai cercato:',
		groupCta: {
			label: 'Visualizza tutti i #GROUP#risultati'
		},
		viewAllLabel: 'Mostra tutti i risultati',
		allResultsName: 'Tutti',
		removeSuggestionLabel: 'Rimuovi suggerimento',
		submitGroupLabel: 'Mostra tutti i risultati della ricerca #GROUP_NAME#',
		suggestionsLayerLabel: 'Ricerca Suggerimenti',
		suggestionsNavigationLabel: 'Suggerimento Gruppi Navigazione'
	},
	errorScreen: {
		offline: {
			title: 'Siete offline',
			message: 'Sembra che ci sia un problema con la vostra rete. Si prega di controllare la vostra connessione internet',
			tryAgain: 'Si prega di riprovare'
		},
		blocked: {
			title: 'Richiesta di ricerca bloccata',
			message: 'Si prega di controllare le estensioni della privacy.',
			tryAgain: 'Si prega di riprovare'
		},
		generic: {
			title: 'Ops!',
			message: 'Qualcosa è andato storto. Mi dispiace!',
			tryAgain: 'Si prega di riprovare'
		},
		siteId: {
			title: 'Manca l\'ID del sito',
			message: 'Si prega di controllare il codice di configurazione e assicurarsi di fornire un ID del sito valido.',
			tryAgain: 'Per saperne di più'
		}
	},
	contentGroups: {
		otherName: 'Altro'
	},
	noResultsPage: {
		title: 'Siamo spiacenti, non abbiamo trovato una corrispondenza esatta per "#QUERY#".',
		description: 'Si prega di provare con un altro termine di ricerca o di modificare la query nel caso in cui ci sia un errore di battitura che non abbiamo colto.',
		fuzzyResults: 'Altri risultati che potrebbero essere utili',
		popularResults: 'Alcuni dei nostri contenuti più popolari',
		popularQueries: 'Le persone cercano spesso'
	},
	comparison: {
		buttonLabel: 'Confronta',
		tooManyProductsLabel: 'Saranno confrontati solo i primi 4 prodotti.',

		heading: 'Confronta Prodotti',
		showDifferencesLabel: 'Mostra solo le differenze',
		ctaText: 'Aggiungi al carrello'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat su #PRODUCT_NAME#' }
	// hiddenViewAllLabel: 'Visualizza tutto'
};

const DA = {
	results: {
		caption: '#COUNT# søgeresultater fundet for <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Se mere',
		noResultsText: 'Vi har desværre ikke fundet nogen forekomster af din forespørgsel.',
		queryCorrectionText: 'Mente du "#CORRECTION#"?',
		queryCorrectionRewrite: 'Viser resultater for "#CORRECTION#"',
		orderByRelevanceText: 'Relevans',
		sortingLabel: 'Sortering:',
		searchResultsLayerLabel: 'Søgeresultater',
		watermarkLabel: 'Drevet af Site Search 360',
		variantsCountLabel: '+#COUNT# yderligere muligheder til rådighed',
		variantsCountLabelSingular: '+1 yderligere mulighed til rådighed',
		queryCorrectionOverride: 'Søg i stedet efter "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Relaterede søgninger:',
		pageDescriptionLabel: 'Viser #COUNT# af #TOTAL# resultater',
		copyLinkToPositionButtonLabel: 'Kopier et link til denne position på listen',
		copiedLinkToPositionButtonLabel: 'Linket er kopieret'
	},
	suggestions: {
		searchHistoryLabel: 'Du har for nylig søgt efter:',
		groupCta: {
			label: 'Vis alle #GROUP#-resultater'
		},
		viewAllLabel: 'Vis alle resultater',
		allResultsName: 'Alle',
		removeSuggestionLabel: 'Fjern forslag',
		submitGroupLabel: 'Vis alle søgeresultater for #GROUP_NAME#',
		suggestionsLayerLabel: 'Forslag til søgning',
		suggestionsNavigationLabel: 'Forslag Grupper Navigation'
	},
	accessibility: {
		searchFieldLabel: 'Søgeforespørgsel',
		srSuggestionsHiddenText: 'Søgeforslag er skjult',
		srNoSuggestionsText: 'Ingen søgeforslag',
		srSuggestionsCountText: '#COUNT# søgeforslag vist',
		srOneSuggestionText: 'Der vises ét søgeforslag',
		srSuggestBoxControlDescription: 'Brug pil op og pil ned til at vælge det tilgængelige resultat. Tryk på Enter for at gå til det valgte søgeresultat. Berøringsenheder, som brugerne kan bruge berørings- og swipebevægelser på.'
	},
	smart404: {
		caption: 'Prøv at gå her i stedet:',
		searchResultsLayerLabel: 'Anbefalede links'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle resultater',
			allResultsTabTitle: 'Alle resultater (#COUNT#)',
			navigationLabel: 'Navigation i søgeresultatet'
		}
	},
	voiceSearch: {
		lang: 'da-DK'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Nulstil alle',
		toggleButtonLabel: 'Filtrere resultater',
		multiSelectSearchLabel: 'Søg #FILTER_NAME#',
		multiSelectEmptyState: 'Ingen tilsvarende filterindstillinger.',
		multiSelectShowMoreLabel: 'Se #COUNT# mere',
		multiSelectShowLessLabel: 'Se færre indstillinger',
		clearGroupLabel: 'Klart',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Maks #UNIT#',
		submitButtonLabel: 'Indsende',
		skipFilter: 'Spring filtre over',
		skipFilterGroup: 'Spring filtergruppe over',
		selectedFilterOptionsLabel: 'Valgte filterindstillinger',
		dayLabel: 'Dag',
		monthLabel: 'Måned',
		yearLabel: 'År',
		sliderResultCountLabel: '(#COUNT# resultater)'
	},
	errorScreen: {
		offline: {
			title: 'Du er offline',
			message: 'Det ser ud til, at der er et problem med dit netværk. Kontroller din internetforbindelse.',
			tryAgain: 'Prøv igen'
		},
		blocked: {
			title: 'Søgeanmodning blokeret',
			message: 'Tjek venligst dine udvidelser til beskyttelse af personlige oplysninger.',
			tryAgain: 'Prøv igen'
		},
		generic: {
			title: 'Ups!',
			message: 'Noget gik galt. Det er jeg ked af!',
			tryAgain: 'Prøv igen'
		},
		siteId: {
			title: 'Websteds-id mangler',
			message: 'Kontroller konfigurationskoden, og sørg for at angive et gyldigt websteds-id.',
			tryAgain: 'Lær mere'
		}
	},
	contentGroups: {
		otherName: 'Andre'
	},
	noResultsPage: {
		title: 'Beklager, vi kunne ikke finde noget præcist match for "#QUERY#"',
		description: 'Prøv venligst et andet søgeord eller juster din forespørgsel, hvis der er en tastefejl, som vi ikke fandt.',
		fuzzyResults: 'Andre resultater, som du måske vil finde nyttige',
		popularResults: 'Noget af vores populære indhold',
		popularQueries: 'Folk søger ofte efter'
	},
	comparison: {
		buttonLabel: 'Sammenlign',
		tooManyProductsLabel: 'Kun de første 4 produkter vil blive sammenlignet.',

		heading: 'Sammenlign Produkter',
		showDifferencesLabel: 'Vis kun forskelle',
		ctaText: 'Læg i kurv'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat om #PRODUCT_NAME#' }
};

const FI = {
	results: {
		caption: 'Löytyi #COUNT# hakutuloksia haulle <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Katso lisää',
		noResultsText: 'Valitettavasti emme löytäneet yhtään vastausta kyselyynne.',
		queryCorrectionText: 'Tarkoititko "#CORRECTION#"?',
		queryCorrectionRewrite: 'Näytetään tulokset "#CORRECTION#"',
		orderByRelevanceText: 'Merkitys',
		sortingLabel: 'Lajittelu:',
		searchResultsLayerLabel: 'Hakutulokset',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# muita vaihtoehtoja käytettävissä',
		variantsCountLabelSingular: '+1 lisävaihtoehto saatavilla',
		queryCorrectionOverride: 'Etsi sen sijaan "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Aiheeseen liittyvät haut:',
		pageDescriptionLabel: 'Näytetään #COUNT# / #TOTAL# tuloksesta',
		copyLinkToPositionButtonLabel: 'Kopioi linkki tähän kohtaan luettelossa',
		copiedLinkToPositionButtonLabel: 'Linkki kopioitu'
	},
	suggestions: {
		searchHistoryLabel: 'Olet hiljattain etsinyt:',
		groupCta: {
			label: 'Näytä kaikki #GROUP# tulokset'
		},
		viewAllLabel: 'Näytä kaikki tulokset',
		allResultsName: 'Kaikki',
		removeSuggestionLabel: 'Poista ehdotus',
		submitGroupLabel: 'Näytä kaikki #GROUP_NAME# hakutulokset',
		suggestionsLayerLabel: 'Hakuehdotukset',
		suggestionsNavigationLabel: 'Ehdotus Ryhmät Navigointi'
	},
	accessibility: {
		searchFieldLabel: 'Hakukysely',
		srSuggestionsHiddenText: 'Hakuehdotukset on piilotettu',
		srNoSuggestionsText: 'Ei hakuehdotuksia',
		srSuggestionsCountText: '#COUNT# näytetyt hakuehdotukset',
		srOneSuggestionText: 'Yksi hakuehdotus näkyy',
		srSuggestBoxControlDescription: 'Valitse käytettävissä oleva tulos ylös- ja alasnuolilla. Siirry valittuun hakutulokseen painamalla enteriä. Kosketuslaitteiden käyttäjät voivat käyttää kosketus- ja pyyhkäisyliikkeitä.'
	},
	smart404: {
		caption: 'Kokeile sen sijaan mennä tänne:',
		searchResultsLayerLabel: 'Suositellut linkit'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Kaikki tulokset',
			allResultsTabTitle: 'Kaikki tulokset (#COUNT#)',
			navigationLabel: 'Hakutulosten navigointi'
		}
	},
	voiceSearch: {
		lang: 'fi-FI'
	},
	filters: {
		label: 'Suodatin',
		deleteAllLabel: 'Nollaa kaikki',
		toggleButtonLabel: 'Suodata tulokset',
		multiSelectSearchLabel: 'Haku #FILTER_NAME#',
		multiSelectEmptyState: 'Ei sopivia suodatinvaihtoehtoja.',
		multiSelectShowMoreLabel: 'Katso #COUNT# lisää',
		multiSelectShowLessLabel: 'Vähemmän vaihtoehtoja',
		clearGroupLabel: 'Tyhjennettävä',
		sliderMinUnitLabel: 'Vähintään #UNIT#',
		sliderMaxUnitLabel: 'Enintään #UNIT#',
		submitButtonLabel: 'Lähetä',
		skipFilter: 'Ohita suodattimet',
		skipFilterGroup: 'Ohita suodatinryhmä',
		selectedFilterOptionsLabel: 'Valitut suodatinvaihtoehdot',
		dayLabel: 'Päivä',
		monthLabel: 'Kuukausi',
		yearLabel: 'Vuosi',
		sliderResultCountLabel: '(#COUNT# tulokset)'
	},
	errorScreen: {
		offline: {
			title: 'Olet offline',
			message: 'Näyttää siltä, että verkossa on ongelma. Tarkista internet-yhteytesi.',
			tryAgain: 'Yritä uudelleen'
		},
		blocked: {
			title: 'Hakupyyntö estetty',
			message: 'Tarkista yksityisyyslaajennukset.',
			tryAgain: 'Yritä uudelleen'
		},
		generic: {
			title: 'Hups!',
			message: 'Jokin meni pieleen. Anteeksi siitä!',
			tryAgain: 'Yritä uudelleen'
		},
		siteId: {
			title: 'Sivuston ID puuttuu',
			message: 'Tarkista konfigurointikoodisi ja varmista, että annat voimassa olevan sivustotunnuksen.',
			tryAgain: 'Lue lisää'
		}
	},
	contentGroups: {
		otherName: 'Muut'
	},
	noResultsPage: {
		title: 'Olemme pahoillamme, emme löytäneet täsmällistä vastaavuutta "#QUERY#"',
		description: 'Kokeile toista hakusanaa tai muokkaa kyselyäsi, jos kyseessä on kirjoitusvirhe, jota emme huomanneet.',
		fuzzyResults: 'Muita hyödyllisiä tuloksia',
		popularResults: 'Suosittua sisältöämme',
		popularQueries: 'Ihmiset etsivät usein'
	},
	comparison: {
		buttonLabel: 'Vertaa',
		tooManyProductsLabel: 'Vain ensimmäiset 4 tuotetta verrataan.',

		heading: 'Vertaa tuotteita',
		showDifferencesLabel: 'Näytä vain erot',
		ctaText: 'Lisää ostoskoriin'
	},
	zoe: { chatLabel: 'Chat', title: 'Chatista #PRODUCT_NAME#' }
};

const SV = {
	results: {
		caption: 'Hittade #COUNT# sökresultat för <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Se mer',
		noResultsText: 'Tyvärr har vi inte hittat några träffar för din fråga.',
		queryCorrectionText: 'Menade du "#CORRECTION#"?',
		queryCorrectionRewrite: 'Visar resultat för "#CORRECTION#"',
		orderByRelevanceText: 'Relevans',
		sortingLabel: 'Sortering:',
		searchResultsLayerLabel: 'Sökresultat',
		watermarkLabel: 'Drivs av Site Search 360',
		variantsCountLabel: '+#COUNT# ytterligare alternativ tillgängliga',
		variantsCountLabelSingular: '+1 fler alternativ tillgängliga',
		queryCorrectionOverride: 'Sök i stället efter "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Relaterade sökningar:',
		pageDescriptionLabel: 'Visar #COUNT# av #TOTAL# resultat',
		copyLinkToPositionButtonLabel: 'Kopiera en länk till denna position i listan',
		copiedLinkToPositionButtonLabel: 'Länken har kopierats'
	},
	suggestions: {
		searchHistoryLabel: 'Du har nyligen sökt efter:',
		groupCta: {
			label: 'Visa alla #GROUP# resultat'
		},
		viewAllLabel: 'Visa alla resultat',
		allResultsName: 'Alla',
		removeSuggestionLabel: 'Ta bort förslag',
		submitGroupLabel: 'Visa alla #GROUP_NAME# sökresultat',
		suggestionsLayerLabel: 'Sök förslag',
		suggestionsNavigationLabel: 'Förslag Grupper Navigation'
	},
	accessibility: {
		searchFieldLabel: 'Sökning',
		srSuggestionsHiddenText: 'Sökförslagen är dolda',
		srNoSuggestionsText: 'Inga förslag till sökning',
		srSuggestionsCountText: '#COUNT# visade sökförslag',
		srOneSuggestionText: 'Ett sökförslag visas',
		srSuggestBoxControlDescription: 'Använd uppåt- och nedåtpilarna för att välja tillgängligt resultat. Tryck på enter för att gå till det valda sökresultatet. Användare av touch-enheter kan använda touch- och svepgester.'
	},
	smart404: {
		caption: 'Försök att gå hit i stället:',
		searchResultsLayerLabel: 'Rekommenderade länkar'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alla resultat',
			allResultsTabTitle: 'Alla Resultat (#COUNT#)',
			navigationLabel: 'Navigering av sökresultat'
		}
	},
	voiceSearch: {
		lang: 'sv-SE'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Återställ alla',
		toggleButtonLabel: 'Filtrera resultat',
		multiSelectSearchLabel: 'Sök #FILTER_NAME#',
		multiSelectEmptyState: 'Inga matchande filteralternativ.',
		multiSelectShowMoreLabel: 'Se #COUNT# mer',
		multiSelectShowLessLabel: 'Se färre alternativ',
		clearGroupLabel: 'Rensa',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Skicka in',
		skipFilter: 'Hoppa över filter',
		skipFilterGroup: 'Hoppa över filtergrupp',
		selectedFilterOptionsLabel: 'Valda filteralternativ',
		dayLabel: 'Dag',
		monthLabel: 'Månad',
		yearLabel: 'År',
		sliderResultCountLabel: '(#COUNT# resultat)'
	},
	errorScreen: {
		offline: {
			title: 'Du är offline',
			message: 'Det verkar som om det finns ett problem med ditt nätverk. Kontrollera din internetanslutning.',
			tryAgain: 'Försök igen'
		},
		blocked: {
			title: 'Begäran om sökning blockerad',
			message: 'Kontrollera dina sekretesstillägg.',
			tryAgain: 'Försök igen'
		},
		generic: {
			title: 'Oops!',
			message: 'Något gick fel. Jag ber om ursäkt för det!',
			tryAgain: 'Försök igen'
		},
		siteId: {
			title: 'Webbplats-ID saknas',
			message: 'Kontrollera din konfigurationskod och se till att du anger ett giltigt webbplats-ID.',
			tryAgain: 'Läs mer'
		}
	},
	contentGroups: {
		otherName: 'Övriga'
	},
	noResultsPage: {
		title: 'Vi kunde tyvärr inte hitta någon exakt matchning för "#QUERY#"',
		description: 'Försök med en annan sökterm eller justera din fråga om det finns ett stavfel som vi inte upptäckte',
		fuzzyResults: 'Andra resultat som du kanske tycker är användbara',
		popularResults: 'Några av våra populära innehåll',
		popularQueries: 'Människor söker ofta efter'
	},
	comparison: {
		buttonLabel: 'Jämför',
		tooManyProductsLabel: 'Endast de första 4 produkterna kommer att jämföras.',

		heading: 'Jämför produkter',
		showDifferencesLabel: 'Visa endast skillnader',
		ctaText: 'Lägg i varukorg'
	},
	zoe: { chatLabel: 'Chatt', title: 'Chatt om #PRODUCT_NAME#' }
};

const NO = {
	results: {
		caption: 'Funnet #COUNT# søkeresultater for <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Se mer',
		noResultsText: 'Beklager, vi har ikke funnet noen treff for søket ditt.',
		queryCorrectionText: 'Mente du "#CORRECTION#"?',
		queryCorrectionRewrite: 'Viser resultater for "#CORRECTION#"',
		orderByRelevanceText: 'Relevans',
		sortingLabel: 'Sortering:',
		searchResultsLayerLabel: 'Søkeresultater',
		watermarkLabel: 'Drevet av Site Search 360',
		variantsCountLabel: '+#COUNT# alternativer til',
		variantsCountLabelSingular: '+1 tilleggsalternativ tilgjengelig',
		queryCorrectionOverride: 'Søk etter "#ORIGINAL_QUERY#" i stedet',
		relatedQueriesTitle: 'Relaterte søk:',
		pageDescriptionLabel: 'Viser #COUNT# av #TOTAL# resultater',
		copyLinkToPositionButtonLabel: 'Kopier en lenke til denne posisjonen i listen',
		copiedLinkToPositionButtonLabel: 'Linken er kopiert'
	},
	suggestions: {
		searchHistoryLabel: 'Du har nylig søkt etter:',
		groupCta: {
			label: 'Vis alle #GROUP# resultater'
		},
		viewAllLabel: 'Vis alle resultater',
		allResultsName: 'Alle',
		removeSuggestionLabel: 'Fjern forslaget',
		submitGroupLabel: 'Vis alle #GROUP_NAME# søkeresultater',
		suggestionsLayerLabel: 'Forslag til søk',
		suggestionsNavigationLabel: 'Forslagsgrupper Navigasjon'
	},
	accessibility: {
		searchFieldLabel: 'Søk etter',
		srSuggestionsHiddenText: 'Søkeforslag er skjult',
		srNoSuggestionsText: 'Ingen søkeforslag',
		srSuggestionsCountText: '#COUNT # søkeforslag vist',
		srOneSuggestionText: 'Ett søkeforslag vist',
		srSuggestBoxControlDescription: 'Bruk opp- og nedpiler for å velge tilgjengelig resultat. Trykk enter for å gå til valgt søkeresultat.Berøringsenheter brukere kan bruke berørings- og sveipebevegelser.'
	},
	smart404: {
		caption: 'Prøv å gå hit i stedet:',
		searchResultsLayerLabel: 'Anbefalte lenker'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle resultater',
			allResultsTabTitle: 'Alle resultater (#COUNT#)',
			navigationLabel: 'Søkeresultatnavigasjon'
		}
	},
	voiceSearch: {
		lang: 'no-NO' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages - Norwegian translated with https://www.translate.com/english-norwegian
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Tilbakestill alle',
		toggleButtonLabel: 'Filtrere resultater',
		multiSelectSearchLabel: 'Søk #FILTER_NAME #',
		multiSelectEmptyState: 'Ingen samsvarende filteralternativer.',
		multiSelectShowMoreLabel: 'Se #COUNT# mer',
		multiSelectShowLessLabel: 'Se færre alternativer',
		clearGroupLabel: 'fjerne',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Maks #UNIT #',
		submitButtonLabel: 'Send inn',
		skipFilter: 'Hopp over filtre',
		skipFilterGroup: 'Hopp over filtergruppe',
		selectedFilterOptionsLabel: 'Valgte filteralternativer',
		dayLabel: 'Dag',
		monthLabel: 'Måned',
		yearLabel: 'År',
		sliderResultCountLabel: '(#COUNT# resultater)'
	},
	errorScreen: {
		offline: {
			title: 'Du er frakoblet',
			message: 'Det ser ut til at det er et problem med nettverket ditt. Vennligst sjekk internettforbindelsen din.',
			tryAgain: 'Prøv igjen'
		},
		blocked: {
			title: 'Søkeforespørsel blokkert',
			message: 'Vennligst sjekk dine personvernutvidelser.',
			tryAgain: 'Prøv igjen'
		},
		generic: {
			title: 'Oops!',
			message: 'Noe gikk galt. Beklager det!',
			tryAgain: 'Prøv igjen'
		},
		siteId: {
			title: 'Område-ID mangler',
			message: 'Kontroller konfigurasjonskoden og sørg for å oppgi en gyldig nettsteds-ID.',
			tryAgain: 'Få mer informasjon'
		}
	},
	contentGroups: {
		otherName: 'Annen'
	},
	noResultsPage: {
		title: 'Vi beklager, vi kunne ikke finne et eksakt treff for "#QUERY#"',
		description: 'Vennligst prøv et annet søkeord eller juster søket ditt i tilfelle det er en skrivefeil vi ikke fanget opp.',
		fuzzyResults: 'Andre resultater som kan være nyttige for deg',
		popularResults: 'Noe av vårt populære innhold',
		popularQueries: 'Folk søker ofte etter'
	},
	comparison: {
		buttonLabel: 'Sammenlign',
		tooManyProductsLabel: 'Bare de første 4 produktene vil bli sammenlignet.',

		heading: 'Sammenlign Produkter',
		showDifferencesLabel: 'Vis kun forskjeller',
		ctaText: 'Legg i handlekurv'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat om #PRODUCT_NAME#' }
};

const LT = {
	results: {
		caption: 'Rasta #COUNT# paieškos rezultatų <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Žr. daugiau',
		noResultsText: 'Atsiprašome, neradome jokių jūsų užklausos atitikmenų.',
		queryCorrectionText: 'Ar turėjote omenyje "#CORRECTION#"?',
		queryCorrectionRewrite: 'Rodomi rezultatai "#CORRECTION#"',
		orderByRelevanceText: 'Aktualumas',
		sortingLabel: 'Rūšiavimas:',
		searchResultsLayerLabel: 'Paieškos rezultatai',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# galimos kitos parinktys',
		variantsCountLabelSingular: '+1 daugiau galimų parinkčių',
		queryCorrectionOverride: 'Vietoj to ieškokite "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Susijusios paieškos:',
		pageDescriptionLabel: 'Rodoma #COUNT# iš #TOTAL# rezultatų',
		copyLinkToPositionButtonLabel: 'Nukopijuokite nuorodą į šią sąrašo vietą',
		copiedLinkToPositionButtonLabel: 'Nuoroda nukopijuota'
	},
	suggestions: {
		searchHistoryLabel: 'Neseniai ieškojote:',
		groupCta: {
			label: 'Peržiūrėti visus #GROUP# rezultatus'
		},
		viewAllLabel: 'Rodyti visus rezultatus',
		allResultsName: 'Visi',
		removeSuggestionLabel: 'Pašalinti pasiūlymą',
		submitGroupLabel: 'Rodyti visus #GROUP_NAME# paieškos rezultatus',
		suggestionsLayerLabel: 'Paieškos pasiūlymai',
		suggestionsNavigationLabel: 'Pasiūlymai Grupės Navigacija'
	},
	accessibility: {
		searchFieldLabel: 'Paieškos užklausa',
		srSuggestionsHiddenText: 'Paieškos pasiūlymai yra paslėpti',
		srNoSuggestionsText: 'Nėra paieškos pasiūlymų',
		srSuggestionsCountText: '#COUNT# rodomi paieškos pasiūlymai',
		srOneSuggestionText: 'Parodytas vienas paieškos pasiūlymas',
		srSuggestBoxControlDescription: 'Rodyklėmis aukštyn ir žemyn pasirinkite galimą rezultatą. Paspauskite Enter, kad pereitumėte prie pasirinkto paieškos rezultato. Jutiklinių įrenginių naudotojai gali naudoti lietimo ir perbraukimo gestus.'
	},
	smart404: {
		caption: 'Pamėginkite apsilankyti čia:',
		searchResultsLayerLabel: 'Rekomenduojamos nuorodos'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Visi rezultatai',
			allResultsTabTitle: 'Visi rezultatai (#COUNT#)',
			navigationLabel: 'Paieškos rezultatų navigacija'
		}
	},
	voiceSearch: {
		lang: 'lt-LT' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages
	},
	filters: {
		label: 'Filtras',
		deleteAllLabel: 'Iš naujo nustatyti viską',
		toggleButtonLabel: 'Filtruoti rezultatus',
		multiSelectSearchLabel: 'Paieška #FILTER_NAME#',
		multiSelectEmptyState: 'Nėra tinkamų filtro parinkčių.',
		multiSelectShowMoreLabel: 'Žr. #COUNT# daugiau',
		multiSelectShowLessLabel: 'Žiūrėkite mažiau parinkčių',
		clearGroupLabel: 'išvalyti',
		sliderMinUnitLabel: 'Minimalus #UNIT#',
		sliderMaxUnitLabel: 'Maksimalus #UNIT#',
		submitButtonLabel: 'Pateikti',
		skipFilter: 'Praleisti filtrus',
		skipFilterGroup: 'Praleisti filtro grupę',
		selectedFilterOptionsLabel: 'Pasirinktos filtro parinktys',
		dayLabel: 'Diena',
		monthLabel: 'Mėnuo',
		yearLabel: 'Metai',
		sliderResultCountLabel: '(#COUNT# rezultatai)'
	},
	errorScreen: {
		offline: {
			title: 'Jūs esate neprisijungęs (-usi)',
			message: 'Atrodo, kad iškilo tinklo problema. Patikrinkite savo interneto ryšį.',
			tryAgain: 'Pabandykite dar kartą'
		},
		blocked: {
			title: 'Užblokuota paieškos užklausa',
			message: 'Patikrinkite privatumo plėtinius.',
			tryAgain: 'Pabandykite dar kartą'
		},
		generic: {
			title: 'Ups!',
			message: 'Kažkas nutiko ne taip. Atsiprašome už tai!',
			tryAgain: 'Pabandykite dar kartą'
		},
		siteId: {
			title: 'Trūksta svetainės ID',
			message: 'Patikrinkite savo konfigūracijos kodą ir įsitikinkite, kad nurodėte galiojantį svetainės ID.',
			tryAgain: 'Sužinokite daugiau'
		}
	},
	contentGroups: {
		otherName: 'Kita'
	},
	noResultsPage: {
		title: 'Atsiprašome, bet neradome tikslaus atitikmens žodžiui "#QUERY#".',
		description: 'Pabandykite kitą paieškos žodį arba pakoreguokite užklausą, jei yra rašybos klaida, kurios nepastebėjome',
		fuzzyResults: 'Kiti rezultatai, kurie jums gali būti naudingi',
		popularResults: 'Keletas mūsų populiaraus turinio',
		popularQueries: 'Žmonės dažnai ieško'
	},
	comparison: {
		buttonLabel: 'Palyginti',
		tooManyProductsLabel: 'Bus palyginti tik pirmi 4 produktai.',

		heading: 'Palyginti Produktus',
		showDifferencesLabel: 'Rodyti tik skirtumus',
		ctaText: 'Pridėti į krepšelį'
	},
	zoe: { chatLabel: 'Pokalbis', title: 'Pokalbis apie #PRODUCT_NAME#' }
};

const RO = {
	results: {
		caption: 'Am găsit #COUNT# rezultate de căutare pentru <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Vezi mai mult',
		noResultsText: 'Ne pare rău, nu am găsit nicio potrivire pentru întrebarea dumneavoastră.',
		queryCorrectionText: 'Ai vrut să spui "#CORRECTION#"?',
		queryCorrectionRewrite: 'Rezultate afișate pentru "#CORRECTION#"',
		orderByRelevanceText: 'Relevanță',
		sortingLabel: 'Sortare:',
		searchResultsLayerLabel: 'Rezultatele căutării',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# alte opțiuni disponibile',
		variantsCountLabelSingular: '+1 altă opțiune disponibilă',
		queryCorrectionOverride: 'Căutați în schimb "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Căutări conexe:',
		pageDescriptionLabel: 'Se afișează #COUNT# din #TOTAL# rezultate',
		copyLinkToPositionButtonLabel: 'Copiați un link către această poziție din listă',
		copiedLinkToPositionButtonLabel: 'Link copiat'
	},
	suggestions: {
		searchHistoryLabel: 'Ați căutat recent pentru:',
		groupCta: {
			label: 'Vezi toate rezultatele #GROUP#'
		},
		viewAllLabel: 'Afișați toate rezultatele',
		allResultsName: 'Toate',
		removeSuggestionLabel: 'Eliminați sugestia',
		submitGroupLabel: 'Afișați toate rezultatele căutării #GROUP_NAME#',
		suggestionsLayerLabel: 'Sugestii de căutare',
		suggestionsNavigationLabel: 'Sugestii Grupuri Navigare'
	},
	accessibility: {
		searchFieldLabel: 'Interogare de căutare',
		srSuggestionsHiddenText: 'Sugestiile de căutare sunt ascunse',
		srNoSuggestionsText: 'Nu există sugestii de căutare',
		srSuggestionsCountText: '#COUNT# sugestii de căutare afișate',
		srOneSuggestionText: 'O sugestie de căutare afișată',
		srSuggestBoxControlDescription: 'Utilizați săgețile sus și jos pentru a selecta rezultatul disponibil. Apăsați enter pentru a merge la rezultatul selectat. Utilizatorii de dispozitive tactile pot folosi gesturile de atingere și glisare.'
	},
	smart404: {
		caption: 'Încearcă să mergi aici în schimb:',
		searchResultsLayerLabel: 'Linkuri recomandate'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Toate rezultatele',
			allResultsTabTitle: 'Toate rezultatele (#COUNT#)',
			navigationLabel: 'Navigare rezultat căutare'
		}
	},
	voiceSearch: {
		lang: 'ro-RO' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages
	},
	filters: {
		label: 'Filtru',
		deleteAllLabel: 'Resetați toate',
		toggleButtonLabel: 'Filtrează rezultatele',
		multiSelectSearchLabel: 'Căutare #FILTER_NAME#',
		multiSelectEmptyState: 'Nu există opțiuni de filtrare corespunzătoare.',
		multiSelectShowMoreLabel: 'Vezi #COUNT# mai mult',
		multiSelectShowLessLabel: 'Vedeți mai puține opțiuni',
		clearGroupLabel: 'ștergeți',
		sliderMinUnitLabel: 'Minim #UNIT#',
		sliderMaxUnitLabel: 'Maxim #UNIT#',
		submitButtonLabel: 'Trimiteți',
		skipFilter: 'Treci peste filtre',
		skipFilterGroup: 'Treceți peste grupul de filtre',
		selectedFilterOptionsLabel: 'Opțiuni de filtrare selectate',
		dayLabel: 'Ziua',
		monthLabel: 'Lună',
		yearLabel: 'An',
		sliderResultCountLabel: '(#COUNT# rezultate)'
	},
	errorScreen: {
		offline: {
			title: 'Sunteți offline',
			message: 'Se pare că există o problemă cu rețeaua dumneavoastră. Vă rugăm să verificați conexiunea la internet.',
			tryAgain: 'Încearcă din nou'
		},
		blocked: {
			title: 'Cerere de căutare blocată',
			message: 'Vă rugăm să verificați extensiile de confidențialitate.',
			tryAgain: 'Încearcă din nou'
		},
		generic: {
			title: 'Ups!',
			message: 'Ceva a mers prost. Îmi pare rău pentru asta!',
			tryAgain: 'Încearcă din nou'
		},
		siteId: {
			title: 'ID-ul sitului lipsește',
			message: 'Vă rugăm să verificați codul de configurare și să vă asigurați că furnizați un ID valid al site-ului.',
			tryAgain: 'Aflați mai multe'
		}
	},
	contentGroups: {
		otherName: 'Altele'
	},
	noResultsPage: {
		title: 'Ne pare rău, nu am găsit o potrivire exactă pentru "#QUERY#"',
		description: 'Vă rugăm să încercați un alt termen de căutare sau să vă ajustați interogarea în cazul în care există o greșeală de scriere pe care nu am găsit-o.',
		fuzzyResults: 'Alte rezultate care v-ar putea fi utile',
		popularResults: 'O parte din conținutul nostru popular',
		popularQueries: 'Oamenii caută adesea'
	},
	comparison: {
		buttonLabel: 'Compară',
		tooManyProductsLabel: 'Doar primele 4 produse vor fi comparate.',

		heading: 'Compară Produsele',
		showDifferencesLabel: 'Arată doar diferențele',
		ctaText: 'Adaugă în coș'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat despre #PRODUCT_NAME#' }
};

const LV = {
	results: {
		caption: 'Atrasts #COUNT# meklēšanas rezultāti <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Skatīt vairāk',
		noResultsText: 'Atvainojiet, mēs neesam atraduši nevienu atbilstību jūsu pieprasījumam.',
		queryCorrectionText: 'Vai Jūs domājāt "#CORRECTION#"?',
		queryCorrectionRewrite: 'Rādīti rezultāti priekš "#CORRECTION#"',
		orderByRelevanceText: 'Atbilstība',
		sortingLabel: 'Šķirošana:',
		searchResultsLayerLabel: 'Meklēšanas rezultāti',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# pieejamas papildu opcijas',
		variantsCountLabelSingular: '+1 pieejama vēl viena opcija',
		queryCorrectionOverride: 'Tā vietā meklējiet "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Saistītās meklēšanas:',
		pageDescriptionLabel: 'Rāda #COUNT# no #TOTAL# rezultātiem',
		copyLinkToPositionButtonLabel: 'Kopējiet saiti uz šo pozīciju sarakstā',
		copiedLinkToPositionButtonLabel: 'Saite nokopēta'
	},
	suggestions: {
		searchHistoryLabel: 'Jūs nesen meklējāt:',
		groupCta: {
			label: 'Apskatīt visus #GROUP# rezultātus'
		},
		viewAllLabel: 'Rādīt visus rezultātus',
		allResultsName: 'Visi',
		removeSuggestionLabel: 'Dzēst ieteikumu',
		submitGroupLabel: 'Rādīt visus #GROUP_NAME# meklēšanas rezultātus',
		suggestionsLayerLabel: 'Meklēšanas ieteikumi',
		suggestionsNavigationLabel: 'Ierosinājumi Grupu navigācija'
	},
	accessibility: {
		searchFieldLabel: 'Meklēšanas vaicājums',
		srSuggestionsHiddenText: 'Meklēšanas ieteikumi ir paslēpti',
		srNoSuggestionsText: 'Nav meklēšanas ieteikumu',
		srSuggestionsCountText: '#COUNT# parādīti meklēšanas ieteikumi',
		srOneSuggestionText: 'Parādīts viens meklēšanas ieteikums',
		srSuggestBoxControlDescription: 'Izmantojiet bultiņas uz augšu un uz leju, lai atlasītu pieejamo rezultātu. Nospiediet Enter, lai pārietu uz izvēlēto meklēšanas rezultātu. Skārienjūtīgo ierīču lietotāji var izmantot pieskārienu un vilkšanas žestus.'
	},
	smart404: {
		caption: 'Tā vietā mēģiniet doties šeit:',
		searchResultsLayerLabel: 'Ieteicamās saites'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Visi rezultāti',
			allResultsTabTitle: 'Visi rezultāti (#COUNT#)',
			navigationLabel: 'Meklēšanas rezultātu navigācija'
		}
	},
	voiceSearch: {
		lang: 'lv-LV' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages
	},
	filters: {
		label: 'Filtrs',
		deleteAllLabel: 'Atiestatīt visu',
		toggleButtonLabel: 'Filtrēšanas rezultāti',
		multiSelectSearchLabel: 'Meklēt #FILTER_NAME#',
		multiSelectEmptyState: 'Nav atbilstošu filtra opciju.',
		multiSelectShowMoreLabel: 'Skatīt #COUNT# vairāk',
		multiSelectShowLessLabel: 'Skatīt mazāk iespēju',
		clearGroupLabel: 'Notīrīt',
		sliderMinUnitLabel: 'Minimālais #UNIT#',
		sliderMaxUnitLabel: 'Maksimālais #UNIT#',
		submitButtonLabel: 'Iesniegt',
		skipFilter: 'Izlaist filtrus',
		skipFilterGroup: 'Izlaist filtru grupu',
		selectedFilterOptionsLabel: 'Izvēlētās filtra opcijas',
		dayLabel: 'Diena',
		monthLabel: 'Mēnesis',
		yearLabel: 'Gads',
		sliderResultCountLabel: '(#COUNT# rezultāti)'
	},
	errorScreen: {
		offline: {
			title: 'Jūs atrodaties bezsaistē',
			message: 'Šķiet, ka ir problēmas ar jūsu tīklu. Lūdzu, pārbaudiet savu interneta savienojumu.',
			tryAgain: 'Mēģiniet vēlreiz'
		},
		blocked: {
			title: 'Bloķēts meklēšanas pieprasījums',
			message: 'Lūdzu, pārbaudiet konfidencialitātes paplašinājumus.',
			tryAgain: 'Mēģiniet vēlreiz'
		},
		generic: {
			title: 'Ak!',
			message: 'Kaut kas notika nepareizi. Atvainojiet par to!',
			tryAgain: 'Mēģiniet vēlreiz'
		},
		siteId: {
			title: 'Trūkst vietnes ID',
			message: 'Lūdzu, pārbaudiet konfigurācijas kodu un pārliecinieties, vai ir norādīts derīgs vietnes ID.',
			tryAgain: 'Uzzināt vairāk'
		}
	},
	contentGroups: {
		otherName: 'Citi'
	},
	noResultsPage: {
		title: 'Atvainojamies, bet neatradām precīzu atbilstu "#QUERY#".',
		description: 'Lūdzu, izmēģiniet citu meklēšanas terminu vai pielāgojiet savu pieprasījumu, ja ir pārrakstīšanās kļūda, ko mēs neesam pamanījuši.',
		fuzzyResults: 'Citi rezultāti, kas jums varētu būt noderīgi',
		popularResults: 'Daži no mūsu populārākajiem materiāliem',
		popularQueries: 'Cilvēki bieži meklē'
	},
	comparison: {
		buttonLabel: 'Salīdzināt',
		tooManyProductsLabel: 'Tiks salīdzināti tikai pirmie 4 produkti.',

		heading: 'Salīdzināt Produktus',
		showDifferencesLabel: 'Rādīt tikai atšķirības',
		ctaText: 'Pievienot grozam'
	},
	zoe: { chatLabel: 'Tērzēšana', title: 'Tērzēšana par #PRODUCT_NAME#' }
};

const EL = {
	results: {
		caption: 'Βρέθηκαν #COUNT# αποτελέσματα αναζήτησης για <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Δείτε περισσότερα',
		noResultsText: 'Λυπούμαστε, δεν βρήκαμε καμία αντιστοιχία για το ερώτημά σας.',
		queryCorrectionText: 'Εννοούσατε "#CORRECTION#"?',
		queryCorrectionRewrite: 'Εμφάνιση αποτελεσμάτων για "#CORRECTION#"',
		orderByRelevanceText: 'Συνάφεια',
		sortingLabel: 'Ταξινόμηση:',
		searchResultsLayerLabel: 'Αποτελέσματα αναζήτησης',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# περαιτέρω διαθέσιμες επιλογές',
		variantsCountLabelSingular: '+1 περισσότερες διαθέσιμες επιλογές',
		queryCorrectionOverride: 'Αναζητήστε αντί για "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Σχετικές αναζητήσεις:',
		pageDescriptionLabel: 'Εμφάνιση #COUNT# από ​​#TOTAL# αποτελέσματα',
		copyLinkToPositionButtonLabel: 'Αντιγράψτε έναν σύνδεσμο προς αυτή τη θέση στη λίστα',
		copiedLinkToPositionButtonLabel: 'Ο σύνδεσμος αντιγράφηκε'
	},
	suggestions: {
		searchHistoryLabel: 'Αναζητήσατε πρόσφατα:',
		groupCta: {
			label: 'Προβολή όλων των αποτελεσμάτων #GROUP#'
		},
		viewAllLabel: 'Εμφάνιση όλων των αποτελεσμάτων',
		allResultsName: 'Όλα',
		removeSuggestionLabel: 'Αφαίρεση πρότασης',
		submitGroupLabel: 'Εμφάνιση όλων των αποτελεσμάτων αναζήτησης #GROUP_NAME#',
		suggestionsLayerLabel: 'Προτάσεις αναζήτησης',
		suggestionsNavigationLabel: 'Πρόταση Ομάδες πλοήγησης Πλοήγηση'
	},
	accessibility: {
		searchFieldLabel: 'Ερώτηση αναζήτησης',
		srSuggestionsHiddenText: 'Οι προτάσεις αναζήτησης είναι κρυμμένες',
		srNoSuggestionsText: 'Δεν υπάρχουν προτάσεις αναζήτησης',
		srSuggestionsCountText: '#COUNT# εμφανιζόμενες προτάσεις αναζήτησης',
		srOneSuggestionText: 'Μια πρόταση αναζήτησης εμφανίζεται',
		srSuggestBoxControlDescription: 'Χρησιμοποιήστε τα πάνω και κάτω βέλη για να επιλέξετε το διαθέσιμο αποτέλεσμα. Πατήστε enter για να μεταβείτε στο επιλεγμένο αποτέλεσμα αναζήτησης. Οι χρήστες συσκευών αφής μπορούν να χρησιμοποιήσουν χειρονομίες αφής και σάρωσης.'
	},
	smart404: {
		caption: 'Δοκιμάστε να πάτε εδώ:',
		searchResultsLayerLabel: 'Συνιστώμενοι σύνδεσμοι'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Όλα τα αποτελέσματα',
			allResultsTabTitle: 'Όλα τα αποτελέσματα (#COUNT#)',
			navigationLabel: 'Πλοήγηση αποτελεσμάτων αναζήτησης'
		}
	},
	voiceSearch: {
		lang: 'el-GR' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages
	},
	filters: {
		label: 'Φίλτρο',
		deleteAllLabel: 'Επαναφορά όλων',
		toggleButtonLabel: 'Αποτελέσματα φιλτραρίσματος',
		multiSelectSearchLabel: 'Αναζήτηση #FILTER_NAME#',
		multiSelectEmptyState: 'Δεν υπάρχουν ταιριαστές επιλογές φίλτρου.',
		multiSelectShowMoreLabel: 'Δείτε #COUNT# περισσότερα',
		multiSelectShowLessLabel: 'Δείτε λιγότερες επιλογές',
		clearGroupLabel: 'καθαρίσετε',
		sliderMinUnitLabel: 'Ελάχιστο #UNIT#',
		sliderMaxUnitLabel: 'Μέγιστο #UNIT#',
		submitButtonLabel: 'Υποβολή',
		skipFilter: 'Παράλειψη φίλτρων',
		skipFilterGroup: 'Παράλειψη ομάδας φίλτρων',
		selectedFilterOptionsLabel: 'Επιλεγμένες επιλογές φίλτρου',
		dayLabel: 'Ημέρα',
		monthLabel: 'Μήνας',
		yearLabel: 'Έτος',
		sliderResultCountLabel: '(#COUNT# αποτελέσματα)'
	},
	errorScreen: {
		offline: {
			title: 'Είσαι εκτός σύνδεσης',
			message: 'Φαίνεται ότι υπάρχει πρόβλημα με το δίκτυό σας. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.',
			tryAgain: 'Δοκιμάστε ξανά'
		},
		blocked: {
			title: 'Αίτημα αναζήτησης μπλοκαρισμένο',
			message: 'Ελέγξτε τις επεκτάσεις απορρήτου σας.',
			tryAgain: 'Δοκιμάστε ξανά'
		},
		generic: {
			title: 'Ουπς!',
			message: 'Κάτι πήγε στραβά. Συγγνώμη γι\' αυτό!',
			tryAgain: 'Δοκιμάστε ξανά'
		},
		siteId: {
			title: 'Λείπει το αναγνωριστικό τοποθεσίας',
			message: 'Ελέγξτε τον κωδικό διαμόρφωσης και βεβαιωθείτε ότι έχετε δώσει ένα έγκυρο αναγνωριστικό ιστότοπου.',
			tryAgain: 'Μάθετε περισσότερα'
		}
	},
	contentGroups: {
		otherName: 'Άλλα'
	},
	noResultsPage: {
		title: 'Λυπούμαστε, δεν μπορέσαμε να βρούμε ακριβή αντιστοιχία για το "#QUERY#"',
		description: 'Παρακαλώ δοκιμάστε έναν άλλο όρο αναζήτησης ή προσαρμόστε το ερώτημά σας σε περίπτωση που υπάρχει κάποιο τυπογραφικό λάθος που δεν εντοπίσαμε.',
		fuzzyResults: 'Άλλα αποτελέσματα που μπορεί να σας φανούν χρήσιμα',
		popularResults: 'Κάποιο από το δημοφιλές περιεχόμενό μας',
		popularQueries: 'Οι άνθρωποι συχνά αναζητούν'
	},
	comparison: {
		buttonLabel: 'Σύγκριση',
		tooManyProductsLabel: 'Μόνο τα πρώτα 4 προϊόντα θα συγκριθούν.',

		heading: 'Σύγκριση Προϊόντων',
		showDifferencesLabel: 'Δείξτε μόνο τις διαφορές',
		ctaText: 'Προσθήκη στο καλάθι'
	},
	zoe: { chatLabel: 'Συνομιλία', title: 'Συνομιλία για το #PRODUCT_NAME#' }
};

const HU = {
	results: {
		caption: 'Talált #COUNT# keresési eredmények <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Lásd még',
		noResultsText: 'Sajnos nem találtunk találatot a keresésedre.',
		queryCorrectionText: 'Úgy értetted, hogy "#CORRECTION#"?',
		queryCorrectionRewrite: 'A "#CORRECTION#" eredményeinek megjelenítése',
		orderByRelevanceText: 'Relevancia',
		sortingLabel: 'Rendezés:',
		searchResultsLayerLabel: 'Keresés eredménye',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# további lehetőségek',
		variantsCountLabelSingular: '+1 további opció elérhető',
		queryCorrectionOverride: 'Helyette keressen az "#ORIGINAL_QUERY#"-re',
		relatedQueriesTitle: 'Kapcsolódó keresések:',
		pageDescriptionLabel: '#COUNT# a #TOTAL# eredményekből #COUNT# megjelenítése',
		copyLinkToPositionButtonLabel: 'Link másolása erre a pozícióra a listában',
		copiedLinkToPositionButtonLabel: 'Másolt link'
	},
	suggestions: {
		searchHistoryLabel: 'Nemrég keresett:',
		groupCta: {
			label: 'Minden #GROUP# eredmény megtekintése'
		},
		viewAllLabel: 'Minden eredmény megjelenítése',
		allResultsName: 'Minden',
		removeSuggestionLabel: 'Javaslat eltávolítása',
		submitGroupLabel: 'Összes #GROUP_NAME# keresési eredmény megjelenítése',
		suggestionsLayerLabel: 'Keresési javaslatok',
		suggestionsNavigationLabel: 'Javaslat Csoportok Navigáció'
	},
	accessibility: {
		searchFieldLabel: 'Keresési lekérdezés',
		srSuggestionsHiddenText: 'A keresési javaslatok el vannak rejtve',
		srNoSuggestionsText: 'Nincsenek keresési javaslatok',
		srSuggestionsCountText: '#COUNT# megjelenített keresési javaslatok',
		srOneSuggestionText: 'Egy keresési javaslat látható',
		srSuggestBoxControlDescription: 'A felfelé és lefelé mutató nyilakkal válassza ki a rendelkezésre álló eredményt. Nyomja meg az enter billentyűt a kiválasztott keresési eredményhez. Az érintőképernyős eszközök felhasználói érintési és húzási gesztusokat használhatnak.'
	},
	smart404: {
		caption: 'Próbáljon inkább ide menni:',
		searchResultsLayerLabel: 'Ajánlott linkek'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Minden eredmény',
			allResultsTabTitle: 'Minden eredmény (#COUNT#)',
			navigationLabel: 'Keresés eredménye Navigáció'
		}
	},
	voiceSearch: {
		lang: 'hu-HU' // updated language code - see https://cloud.google.com/speech-to-text/docs/languages
	},
	filters: {
		label: 'Szűrő',
		deleteAllLabel: 'Minden visszaállítása',
		toggleButtonLabel: 'Eredmények szűrése',
		multiSelectSearchLabel: 'Keresés #FILTER_NAME#',
		multiSelectEmptyState: 'Nincs megfelelő szűrési lehetőség.',
		multiSelectShowMoreLabel: 'Lásd #COUNT# tovább',
		multiSelectShowLessLabel: 'Kevesebb lehetőség megtekintése',
		clearGroupLabel: 'Törölni',
		sliderMinUnitLabel: 'Minimum #UNIT#',
		sliderMaxUnitLabel: 'Maximális #UNIT#',
		submitButtonLabel: 'Küldje be a',
		skipFilter: 'Szűrők kihagyása',
		skipFilterGroup: 'Szűrőcsoport kihagyása',
		selectedFilterOptionsLabel: 'Kiválasztott szűrési lehetőségek',
		dayLabel: 'Nap',
		monthLabel: 'Hónap',
		yearLabel: 'Év',
		sliderResultCountLabel: '(#COUNT# eredmények)'
	},
	errorScreen: {
		offline: {
			title: 'Offline vagy',
			message: 'Úgy tűnik, probléma van a hálózatoddal. Kérjük, ellenőrizze az internetkapcsolatát.',
			tryAgain: 'Próbálja újra'
		},
		blocked: {
			title: 'Keresési kérelem blokkolva',
			message: 'Kérjük, ellenőrizze az adatvédelmi kiterjesztéseket.',
			tryAgain: 'Próbálja újra'
		},
		generic: {
			title: 'Hoppá!',
			message: 'Valami rosszul sült el. Elnézést kérek érte!',
			tryAgain: 'Próbálja újra'
		},
		siteId: {
			title: 'Hiányzó helyszín azonosító',
			message: 'Kérjük, ellenőrizze a konfigurációs kódot, és győződjön meg róla, hogy érvényes webhelyazonosítót adott meg.',
			tryAgain: 'Tudjon meg többet'
		}
	},
	contentGroups: {
		otherName: 'Egyéb'
	},
	noResultsPage: {
		title: 'Sajnáljuk, de nem találtunk pontos egyezést a "#QUERY#" kifejezésre.',
		description: 'Kérjük, próbáljon meg egy másik kereső kifejezést, vagy módosítsa a lekérdezést, ha van egy elírás, amit nem találtunk meg.',
		fuzzyResults: 'Más találatok, amelyeket hasznosnak találhat',
		popularResults: 'Néhány népszerű tartalmunk',
		popularQueries: 'Az emberek gyakran keresnek'
	},
	comparison: {
		buttonLabel: 'Összehasonlítás',
		tooManyProductsLabel: 'Csak az első 4 termék lesz összehasonlítva.',

		heading: 'Termékek Összehasonlítása',
		showDifferencesLabel: 'Csak a különbségeket mutassa',
		ctaText: 'Kosárba'
	},
	zoe: { chatLabel: 'Chat', title: 'Csevegés a #PRODUCT_NAME#-ról' }
};

const CZ = {
	results: {
		caption: 'Nalezeno #COUNT# výsledků hledání pro <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Zobrazit další',
		noResultsText: 'Je nám líto, ale nenašli jsme žádné výsledky.',
		queryCorrectionText: 'Mysleli jste "#CORRECTION#"?',
		queryCorrectionRewrite: 'Zobrazují se výsledky pro "#CORRECTION#"',
		orderByRelevanceText: 'Relevance',
		sortingLabel: 'Seřadit:',
		searchResultsLayerLabel: 'Výsledky vyhledávání',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# dalších variant',
		variantsCountLabelSingular: '+1 další varianta',
		queryCorrectionOverride: 'Místo toho hledejte "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Související vyhledávání:',
		pageDescriptionLabel: 'Zobrazuje se #COUNT# z #TOTAL# výsledků',
		copyLinkToPositionButtonLabel: 'Zkopírovat odkaz na tuto pozici v seznamu',
		copiedLinkToPositionButtonLabel: 'Odkaz zkopírován'
	},
	suggestions: {
		searchHistoryLabel: 'Nedávno jste hledali:',
		groupCta: {
			label: 'Zobrazit všechny výsledky #GROUP#'
		},
		viewAllLabel: 'Zobrazit všechny výsledky',
		allResultsName: 'Všechny',
		removeSuggestionLabel: 'Odstranit',
		submitGroupLabel: 'Zobrazit všechny výsledky v #GROUP_NAME#',
		suggestionsLayerLabel: 'Našeptávač',
		suggestionsNavigationLabel: 'Navigace našeptávače'
	},
	accessibility: {
		searchFieldLabel: 'Vyhledávací dotaz',
		srSuggestionsHiddenText: 'Návrhy vyhledávání jsou skryté',
		srNoSuggestionsText: 'Žádné návrhy vyhledávání',
		srSuggestionsCountText: '#COUNT# zobrazené návrhy vyhledávání',
		srOneSuggestionText: 'Jeden ze zobrazených návrhů vyhledávání',
		srSuggestBoxControlDescription: 'Pomocí šipek nahoru a dolů vyberte dostupný výsledek. Stisknutím klávesy enter přejdete na vybraný výsledek hledání. Uživatelé dotykových zařízení mohou používat dotyková gesta a gesta přejetí prstem.'
	},
	smart404: {
		caption: 'Zkuste jít raději sem:',
		searchResultsLayerLabel: 'Doporučené odkazy'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Všechny výsledky',
			allResultsTabTitle: 'Všechny výsledky (#COUNT#)',
			navigationLabel: 'Navigace ve výsledcích vyhledávání'
		}
	},
	voiceSearch: {
		lang: 'cs-CZ' // keep this line :)
	},
	filters: {
		label: 'Filtrování',
		deleteAllLabel: 'Zrušit všechny filtry',
		toggleButtonLabel: 'Filtrovat',
		multiSelectSearchLabel: 'Hledejte v #FILTER_NAME#',
		multiSelectEmptyState: 'Žádné možnosti.',
		multiSelectShowMoreLabel: 'Zobrazit #COUNT# dalších',
		multiSelectShowLessLabel: 'Zobrazit méně možností',
		clearGroupLabel: 'vymazat',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Odeslat',
		skipFilter: 'Přeskočit filtry',
		skipFilterGroup: 'Přeskočit skupinu filtrů',
		selectedFilterOptionsLabel: 'Vybrané možnosti filtru',
		dayLabel: 'Den',
		monthLabel: 'Měsíc',
		yearLabel: 'Rok',
		sliderResultCountLabel: '(#COUNT# výsledků)'
	},
	errorScreen: {
		offline: {
			title: 'Jste offline',
			message: 'Zdá se, že je problém ve vaší síti. Zkontrolujte prosím své internetové připojení.',
			tryAgain: 'Zkuste to znovu'
		},
		blocked: {
			title: 'Požadavek na vyhledávání zablokován',
			message: 'Zkontrolujte si prosím rozšíření ochrany soukromí.',
			tryAgain: 'Zkuste to znovu'
		},
		generic: {
			title: 'Ups!',
			message: 'Něco se pokazilo. Omlouváme se za to!',
			tryAgain: 'Zkuste to znovu'
		},
		siteId: {
			title: 'Chybí ID stránky',
			message: 'Zkontrolujte prosím konfiguraci vyhledávání a ujistěte se, že jste zadali platné ID webu.',
			tryAgain: 'Zjistěte více'
		}
	},
	contentGroups: {
		otherName: 'Ostatní'
	},
	noResultsPage: {
		title: 'Je nám líto, ale pro výraz "#QUERY#" se nám nepodařilo najít přesnou shodu.',
		description: 'Zkuste prosím použít jiný vyhledávací výraz nebo upravte svůj dotaz v případě, že jsme nezachytili překlep.',
		fuzzyResults: 'Další výsledky, které by se vám mohly hodit',
		popularResults: 'Oblíbený obsah',
		popularQueries: 'Ostatní často hledají'
	},
	comparison: {
		buttonLabel: 'Porovnat',
		tooManyProductsLabel: 'Porovnány budou pouze první 4 produkty.',

		heading: 'Porovnání produktů',
		showDifferencesLabel: 'Zobrazit pouze rozdíly',
		ctaText: 'Přidat do košíku'
	},
	zoe: { chatLabel: 'Chat', title: 'Chat o #PRODUCT_NAME#' }
};

const RU = {
	results: {
		caption: '#COUNT#: столько результатов нашлось по запросу <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		moreResultsButton: 'Показать еще',
		noResultsText: 'Извините, по этому запросу ничего не нашлось.',
		queryCorrectionText: 'Возможно, вы имели в виду "CORRECTION"?',
		queryCorrectionRewrite: 'Результаты по запросу "#CORRECTION#".',
		orderByRelevanceText: 'По релевантности',
		sortingLabel: 'Сортировать:',
		searchResultsLayerLabel: 'Результаты поиска',
		watermarkLabel: 'Powered by Site Search 360',
		variantsCountLabel: '+#COUNT# дополнительные опции',
		variantsCountLabelSingular: '+1 дополнительная опция доступна',
		queryCorrectionOverride: 'Вместо этого ищите "#ORIGINAL_QUERY#"',
		relatedQueriesTitle: 'Связанные поиски:',
		pageDescriptionLabel: 'отображается #COUNT# из #ТОТАL# результатов',
		copyLinkToPositionButtonLabel: 'Копирование ссылки на эту позицию в списке',
		copiedLinkToPositionButtonLabel: 'Ссылка скопирована'
	},
	suggestions: {
		searchHistoryLabel: 'Вы недавно искали:',
		groupCta: {
			label: 'Все результаты в группе #GROUP#'
		},
		viewAllLabel: 'Показать все результаты',
		allResultsName: 'Все',
		removeSuggestionLabel: 'Удалить предложение',
		submitGroupLabel: 'Показать все результаты поиска #GROUP_NAME#',
		suggestionsLayerLabel: 'Поиск предложений',
		suggestionsNavigationLabel: 'Навигация по группам предложений'
	},
	accessibility: {
		searchFieldLabel: 'поисковый запрос',
		srSuggestionsHiddenText: 'Поисковые подсказки скрыты',
		srNoSuggestionsText: 'Поисковых подсказок не нашлось',
		srSuggestionsCountText: 'Показано поисковых подсказок: #COUNT#',
		srOneSuggestionText: 'Показана одна поисковая подсказка',
		srSuggestBoxControlDescription: 'Используйте стрелки вверх и вниз для выбора нужного результата. Нажмите клавишу enter, чтобы перейти к выбранному результату поиска. Пользователи сенсорных устройств могут использовать жесты касания и пролистывания.'
	},
	smart404: {
		caption: 'Зато нашлись вот такие варианты:',
		searchResultsLayerLabel: 'Рекомендуемые ссылки'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Все результаты',
			allResultsTabTitle: 'Все результаты (#COUNT#)',
			navigationLabel: 'Навигация по результатам поиска'
		}
	},
	voiceSearch: {
		lang: 'ru-RU' // keep this line :)
	},
	filters: {
		label: 'Фильтр',
		deleteAllLabel: 'Сбросить все',
		toggleButtonLabel: 'Фильтровать результаты',
		multiSelectSearchLabel: 'Искать #FILTER_NAME#',
		multiSelectEmptyState: 'Не нашлось результатов по заданному фильтру.',
		multiSelectShowMoreLabel: 'Показать еще #COUNT#',
		multiSelectShowLessLabel: 'Скрыть',
		clearGroupLabel: 'Сбросить',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Применить',
		skipFilter: 'Пропустить фильтры',
		skipFilterGroup: 'Пропустить группу фильтров',
		selectedFilterOptionsLabel: 'Выбранные параметры фильтра',
		dayLabel: 'День',
		monthLabel: 'Месяц',
		yearLabel: 'Год',
		sliderResultCountLabel: '(#COUNT# результатов)'
	},
	errorScreen: {
		offline: {
			title: 'Нет сети',
			message: 'Пожалуйста, проверьте ваше подключение к интернету и попробуйте еще раз.',
			tryAgain: 'Пробуем'
		},
		blocked: {
			title: 'Поисковый запрос заблокирован',
			message: 'Возможно, его перехватил блокировщик рекламы в вашем браузере. Отключите соответствующий плагин и попробуйте еще раз.',
			tryAgain: 'Пробуем'
		},
		generic: {
			title: 'Упс, что-то пошло не так',
			message: 'Попробуем еще раз?',
			tryAgain: 'Пробуем'
		},
		siteId: {
			title: 'Site ID отсутствует или неверен',
			message: 'Пожалуйста, проверьте что в JavaScript-коде, добавленном на ваш сайт, указан верный Site ID.',
			tryAgain: 'Подробнее (на английском)'
		}
	},
	contentGroups: {
		otherName: 'Другие'
	},
	noResultsPage: {
		title: 'Извините, мы не смогли найти точного совпадения для "#QUERY#".',
		description: 'Пожалуйста, попробуйте другой поисковый запрос или скорректируйте запрос, если мы не нашли опечатку.',
		fuzzyResults: 'Другие результаты, которые могут быть вам полезны',
		popularResults: 'Некоторые из наших популярных материалов',
		popularQueries: 'Люди часто ищут'
	},
	comparison: {
		buttonLabel: 'Сравнить',
		tooManyProductsLabel: 'Будут сравниваться только первые 4 продукта.',

		heading: 'Сравнить продукты',
		showDifferencesLabel: 'Показать только различия',
		ctaText: 'Добавить в корзину'
	},
	zoe: { chatLabel: 'Чат', title: 'Чат о #PRODUCT_NAME#' }
};

const IS = {
	results: {
		caption: 'Fann #COUNT# leitarniðurstöður fyrir \"#QUERY#\"',
		moreResultsButton: 'Sjá meira',
		noResultsText: 'Við fundum því miður ekkert sem passaði við leitina.',
		queryCorrectionText: 'Áttir þú við \"#CORRECTION#\"?',
		queryCorrectionRewrite: 'Sýni leitarniðurstöður fyrir \"#CORRECTION#\"',
		orderByRelevanceText: 'Skyldleiki',
		sortingLabel: 'Röðun:',
		searchResultsLayerLabel: 'Leitarniðurstöður',
		watermarkLabel: 'Keyrt á Site Search 360',
		variantsCountLabel: '+#COUNT# fleiri möguleikar í boði',
		variantsCountLabelSingular: '+#COUNT# annar möguleiki í boði',
		relatedQueriesTitle: 'Tengdar leitir:',
		pageDescriptionLabel: '#COUNT# af #TOTAL# niðurstöðum birtar',
		copyLinkToPositionButtonLabel: 'Afritaðu tengil á þessa stöðu á listanum',
		copiedLinkToPositionButtonLabel: 'Tengill afritaður'
	},
	contentGroups: {
		allResultsTabName: 'Annað'
	},
	accessibility: {
		searchFieldLabel: 'Leitarorð',
		srSuggestionsHiddenText: 'Leitartillögur eru faldar',
		srNoSuggestionsText: 'Engar leitartillögur',
		srSuggestionsCountText: '#COUNT# leitartillögur sýndar',
		srOneSuggestionText: 'Ein leitarniðurstaða sýnd',
		srSuggestBoxControlDescription: 'Notaðu upp og niður örvarnar til að velja niðurstöðu. Ýttu á Enter hnappinn til að fara á valda niðurstöðu. Á snertiskjám er hægt að velja og skruna með hefðbundnum hreyfingum.'
	},
	smart404: {
		caption: 'Reyndu eitt af þessu í staðinn:',
		searchResultsLayerLabel: 'Tillögur að tenglum'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Allar niðurstöður',
			allResultsTabTitle: 'Allar niðurstöður (#COUNT#)',
			navigationLabel: 'Yfirlit yfir leitarniðurstöður'
		}
	},
	voiceSearch: {
		lang: 'is-IS'
	},
	filters: {
		label: 'Sía',
		deleteAllLabel: 'Endurstilla allt',
		toggleButtonLabel: 'Sía niðurstöður',
		multiSelectSearchLabel: 'Leita að #FILTER_NAME#',
		multiSelectEmptyState: 'Engir samsvarandi síuvalkostir.',
		multiSelectShowMoreLabel: 'Sjá #COUNT# fleiri',
		multiSelectShowLessLabel: 'Sjá færri valkosti',
		clearGroupLabel: 'hreinsa',
		sliderMinUnitLabel: 'Lágmark #UNIT#',
		sliderMaxUnitLabel: 'Hámark #UNIT#',
		submitButtonLabel: 'Velja',
		skipFilter: 'Sleppa síum',
		skipFilterGroup: 'Sleppa síuhóp',
		selectedFilterOptionsLabel: 'Valdir síuvalkostir',
		dayLabel: 'Dagur',
		monthLabel: 'Mánuður',
		yearLabel: 'Ár',
		sliderResultCountLabel: '(#COUNT# niðurstöður)'
	},
	suggestions: {
		searchHistoryLabel: 'Þú leitaðir nýlega að:',
		viewAllLabel: 'Sýna allt',
		groupCta: {
			label: 'Sýna allar #GROUP# niðurstöður'
		},
		allResultsName: 'Allar',
		submitGroupLabel: 'Sýna allar #GROUP_NAME# leitarniðurstöður',
		suggestionsLayerLabel: 'Leitartillögur',
		suggestionsNavigationLabel: 'Tillögur að yfirliti fyrir hópa'
	},
	errorScreen: {
		offline: {
			title: 'Engin nettenging',
			message: 'Það virðist vera vandamál með netið. Vinsamlegast athugaðu nettenginguna þína.',
			tryAgain: 'Reyna aftur'
		},
		blocked: {
			title: 'Lokað er fyrir leitina',
			message: 'Vinsamlegast athugaðu friðhelgisviðbæturnar þínar.',
			tryAgain: 'Reyna aftur'
		},
		generic: {
			title: 'Úbbs!',
			message: 'Eitthvað fór úrskeiðis. Afsakaðu það!',
			tryAgain: 'Reyna aftur'
		},
		siteId: {
			title: 'Auðkenni vefsvæðis vantar',
			message: 'Vinsamlegast athugaðu stillingarnar þínar og vertu viss um að gefa upp gilt auðkenni vefsvæðis.',
			tryAgain: 'Nánari upplýsingar'
		},
		ipBlocked: {
			title: 'Lokað',
			message: 'Þú hefur ekki aðgang að þessari þjónustu.'
		}
	},
	noResultsPage: {
		title: 'Því miður gátum við ekki fundið nákvæma samsvörun fyrir <span class="ss360-layer__heading-query">"#QUERY#"</span>',
		description: 'Vinsamlegast reyndu annað leitarorð eða breyttu fyrirspurn þinni ef það er prentvilla sem við náðum ekki',
		fuzzyResults: 'Aðrar niðurstöður sem þér gæti fundist gagnlegar',
		popularResults: 'Sumt af vinsæla efninu okkar',
		popularQueries: 'Fólk leitar oft að'
	},
	comparison: {
		buttonLabel: 'Bera saman',
		tooManyProductsLabel: 'Aðeins fyrstu 4 vörurnar verða bornar saman.',

		heading: 'Bera saman vörur',
		showDifferencesLabel: 'Sýna aðeins mismun',
		ctaText: 'Bæta í körfu'
	},
	zoe: { chatLabel: 'Spjall', title: 'Spjall um #PRODUCT_NAME#' }
};

const KO = {
	suggestions: {
		allResultsName: '전체',
		removeSuggestionLabel: '제안 제거',
		submitGroupLabel: '모든 #GROUP_NAME# 검색 결과 보기',
		suggestionsLayerLabel: '검색 제안',
		suggestionsNavigationLabel: '제안 그룹 탐색'
	},
	results: {
		caption: '#QUERY#에 대한 검색 결과 #COUNT#개 찾음',
		moreResultsButton: '더 보기',
		noResultsText: '죄송합니다. 검색어에 대한 일치 항목을 찾을 수 없습니다.',
		queryCorrectionText: '"#CORRECTION#"을(를) 찾으셨나요?',
		queryCorrectionOverride: '대신 "#ORIGINAL_QUERY#" 검색',
		orderByRelevanceText: '관련성',
		sortingLabel: '정렬:',
		searchResultsLayerLabel: '검색 결과',
		watermarkLabel: 'Site Search 360 제공',
		variantsCountLabel: '+#COUNT#개의 추가 옵션 사용 가능',
		variantsCountLabelSingular: '+#COUNT#개의 추가 옵션 사용 가능',
		relatedQueriesTitle: '관련 검색:',
		pageDescriptionLabel: '#COUNT#개 중 #TOTAL#개의 결과 표시',
		copyLinkToPositionButtonLabel: '목록의 이 위치에 대한 링크 복사',
		copiedLinkToPositionButtonLabel: '링크가 복사되었습니다'
	},
	accessibility: {
		searchFieldLabel: '검색어',
		srSuggestionsHiddenText: '검색 제안이 숨겨져 있습니다',
		srNoSuggestionsText: '검색 제안 없음',
		srSuggestionsCountText: '#COUNT#개의 검색 제안 표시',
		srOneSuggestionText: '하나의 검색 제안 표시',
		srSuggestBoxControlDescription: '위아래 화살표를 사용하여 결과를 선택합니다. Enter를 눌러 선택한 검색 결과로 이동합니다. 터치 장치 사용자는 터치 및 스와이프 제스처를 사용할 수 있습니다.'
	},
	smart404: {
		identifier: '페이지를 찾을 수 없음',
		caption: '대신 여기를 시도하십시오:',
		searchResultsLayerLabel: '추천 링크'
	},
	layout: {
		navigation: {
			tabTitle: '#NAME# (#COUNT#)',
			allResultsTabName: '모든 결과',
			allResultsTabTitle: '모든 결과 (#COUNT#)'
		}
	},
	filters: {
		label: '필터',
		deleteAllLabel: '모두 재설정',
		toggleButtonLabel: '필터 결과',
		multiSelectSearchLabel: '#FILTER_NAME# 검색',
		multiSelectEmptyState: '일치하는 필터 옵션이 없습니다.',
		multiSelectShowMoreLabel: '#COUNT#개 더 보기',
		multiSelectShowLessLabel: '적은 옵션 보기',
		clearGroupLabel: '지우기',
		sliderMinUnitLabel: '최소 #UNIT#',
		sliderMaxUnitLabel: '최대 #UNIT#',
		submitButtonLabel: '설정',
		skipFilter: '필터 건너뛰기',
		skipFilterGroup: '필터 그룹 건너뛰기',
		selectedFilterOptionsLabel: '선택된 필터 옵션',
		dayLabel: '일',
		monthLabel: '월',
		yearLabel: '년'
	},
	errorScreen: {
		offline: {
			title: '오프라인 상태입니다',
			message: '네트워크에 문제가 있는 것 같습니다. 인터넷 연결을 확인하십시오.',
			tryAgain: '다시 시도'
		},
		blocked: {
			title: '검색 요청이 차단됨',
			message: '개인 정보 확장 기능을 확인하십시오.',
			tryAgain: '다시 시도'
		},
		generic: {
			title: '이런!',
			message: '문제가 발생했습니다. 죄송합니다!',
			tryAgain: '다시 시도'
		},
		siteId: {
			title: '사이트 ID 누락',
			message: '구성 코드를 확인하고 유효한 사이트 ID를 제공하십시오.',
			tryAgain: '자세히 알아보기'
		},
		ipBlocked: {
			title: '차단됨',
			message: '이 서비스를 사용할 수 없습니다.'
		}
	},
	similarContent: {
		buttonLabel: '이와 유사한 더 보기',
		title: '이와 유사한 더 보기',
		emptyStateTitle: '이런!',
		emptyStateText: '이 항목에 대한 유사한 결과를 찾을 수 없습니다. 다른 항목을 시도해 보십시오.'
	},
	noResultsPage: {
		title: '죄송합니다. "#QUERY#"에 대한 정확한 일치 항목을 찾을 수 없습니다',
		description: '다른 검색어를 시도하거나 철자가 잘못된 경우 검색어를 조정하십시오.',
		fuzzyResults: '유용할 수 있는 다른 결과',
		popularResults: '인기 있는 콘텐츠',
		popularQueries: '사람들이 자주 검색하는 항목'
	},
	comparison: {
		buttonLabel: '비교',
		tooManyProductsLabel: '최대 4개의 제품만 비교됩니다.',

		heading: '제품 비교',
		showDifferencesLabel: '차이점만 보기',
		ctaText: '장바구니에 추가'
	},
	zoe: { chatLabel: '채팅', title: '#PRODUCT_NAME#에 대한 채팅' }
};

const JA = {
	suggestions: {
		allResultsName: 'すべて',
		removeSuggestionLabel: '提案を削除',
		submitGroupLabel: 'すべての #GROUP_NAME# 検索結果を表示',
		suggestionsLayerLabel: '検索提案',
		suggestionsNavigationLabel: '提案グループナビゲーション'
	},
	results: {
		moreResultsButton: 'さらに表示',
		noResultsText: '申し訳ありませんが、お探しのクエリに一致するものが見つかりませんでした。',
		queryCorrectionText: '"#CORRECTION#" ですか？',
		queryCorrectionOverride: '代わりに "#ORIGINAL_QUERY#" を検索',
		orderByRelevanceText: '関連性',
		sortingLabel: '並び替え:',
		searchResultsLayerLabel: '検索結果',
		watermarkLabel: 'Site Search 360 提供',
		variantsCountLabel: '+#COUNT# の追加オプションが利用可能',
		variantsCountLabelSingular: '+#COUNT# の追加オプションが利用可能',
		relatedQueriesTitle: '関連検索:',
		pageDescriptionLabel: '#COUNT# 件中 #TOTAL# 件を表示',
		copyLinkToPositionButtonLabel: 'この位置へのリンクをコピー',
		copiedLinkToPositionButtonLabel: 'リンクがコピーされました',
		caption: '<span class="ss360-layer__heading-query">"#QUERY#"</span> の検索結果が #COUNT# 件見つかりました'
	},
	accessibility: {
		searchFieldLabel: '検索クエリ',
		srSuggestionsHiddenText: '検索提案が非表示です',
		srNoSuggestionsText: '検索提案がありません',
		srSuggestionsCountText: '#COUNT# 件の検索提案が表示されました',
		srOneSuggestionText: '1 件の検索提案が表示されました',
		srSuggestBoxControlDescription: '上下の矢印キーを使用して結果を選択します。Enterキーを押して選択した検索結果に移動します。タッチデバイスのユーザーはタッチおよびスワイプジェスチャーを使用できます。'
	},
	smart404: {
		identifier: 'ページが見つかりません',
		caption: '代わりにこちらに移動してみてください:',
		searchResultsLayerLabel: 'おすすめリンク'
	},
	layout: {
		navigation: {
			tabTitle: '#NAME# (#COUNT#)',
			allResultsTabName: 'すべての結果',
			allResultsTabTitle: 'すべての結果 (#COUNT#)'
		}
	},
	filters: {
		label: 'フィルター',
		deleteAllLabel: 'すべてリセット',
		toggleButtonLabel: 'フィルター結果',
		multiSelectSearchLabel: '#FILTER_NAME# を検索',
		multiSelectEmptyState: '一致するフィルターオプションがありません。',
		multiSelectShowMoreLabel: '#COUNT# 件をさらに表示',
		multiSelectShowLessLabel: '少ないオプションを表示',
		clearGroupLabel: 'クリア',
		sliderMinUnitLabel: '最小 #UNIT#',
		sliderMaxUnitLabel: '最大 #UNIT#',
		submitButtonLabel: '設定',
		skipFilter: 'フィルターをスキップ',
		skipFilterGroup: 'フィルターグループをスキップ',
		selectedFilterOptionsLabel: '選択されたフィルターオプション',
		dayLabel: '日',
		monthLabel: '月',
		yearLabel: '年'
	},
	errorScreen: {
		offline: {
			title: 'オフラインです',
			message: 'ネットワークに問題があるようです。インターネット接続を確認してください。',
			tryAgain: '再試行'
		},
		blocked: {
			title: '検索リクエストがブロックされました',
			message: 'プライバシー拡張機能を確認してください。',
			tryAgain: '再試行'
		},
		generic: {
			title: 'おっとっと！',
			message: '問題が発生しました。申し訳ありません！',
			tryAgain: '再試行'
		},
		siteId: {
			title: 'サイトIDが見つかりません',
			message: '構成コードを確認し、有効なサイトIDを提供してください。',
			tryAgain: '詳細'
		},
		ipBlocked: {
			title: 'ブロックされました',
			message: 'このサービスを使用することはできません。'
		}
	},
	similarContent: {
		buttonLabel: 'これに似たものをもっと見る',
		title: 'これに似たものをもっと見る',
		emptyStateTitle: 'おっとっと！',
		emptyStateText: 'このアイテムに似た結果が見つかりませんでした。別のものを試してください。'
	},
	noResultsPage: {
		title: '申し訳ありませんが、"#QUERY#" に完全一致するものが見つかりませんでした',
		description: '他の検索語句を試すか、誤字脱字がないか検索クエリを調整してください。',
		fuzzyResults: '役立つかもしれないその他の結果',
		popularResults: '人気のコンテンツ',
		popularQueries: 'よく検索される項目'
	},
	comparison: {
		buttonLabel: '比較',
		tooManyProductsLabel: '最初の4つの製品のみ比較されます。',
		heading: '製品の比較',
		showDifferencesLabel: '違いのみを表示',
		ctaText: 'カートに追加'
	},
	zoe: { chatLabel: 'チャット', title: '#PRODUCT_NAME# についてチャットする' }
};

const additionalTranslations = {
	variantsLabel: {
		FR: 'Variantes de produit',
		DE: 'Produktvarianten',
		NL: 'Productvarianten',
		PL: 'Warianty produktu',
		TR: 'Ürün Varyantları',
		PT: 'Variantes de Produto',
		ES: 'Variantes del Producto',
		ES_MX: 'Variantes del Producto',
		IT: 'Varianti del Prodotto',
		DA: 'Produktvarianter',
		FI: 'Tuoteversiot',
		SV: 'Produktvarianter',
		NO: 'Produktvarianter',
		LT: 'Produkto Variantai',
		RO: 'Variante de Produs',
		LV: 'Produkta Varianti',
		EL: 'Παραλλαγές Προϊόντων',
		HU: 'Termékváltozatok',
		CZ: 'Varianty Produktu',
		RU: 'Варианты Продукции',
		IS: 'Afbrigði Vöru',
		KO: '제품 변형',
		JA: '製品バリエーション'
	},
	addToCartLabel: {
		FR: 'Ajouter au panier',
		DE: 'In den Warenkorb',
		NL: 'Toevoegen aan winkelwagentje',
		PL: 'Dodaj do koszyka',
		TR: 'Sepete ekle',
		PT: 'Adicionar ao carrinho',
		ES: 'Añadir al carrito',
		ES_MX: 'Añadir al carrito',
		IT: 'Aggiungi al carrello',
		DA: 'Tilføj til kurv',
		FI: 'Lisää ostoskoriin',
		SV: 'Lägg i varukorg',
		NO: 'Legg i handlekurv',
		LT: 'Įdėti į krepšelį',
		RO: 'Adaugă în coș',
		LV: 'Pievienot grozam',
		EL: 'Προσθήκη στο καλάθι',
		HU: 'Hozzáadás a kosárhoz',
		CZ: 'Přidat do košíku',
		RU: 'Добавить в корзину',
		IS: 'Bæta í körfu',
		KO: '장바구니에 추가',
		JA: 'カートに追加'
	},
	inStock: {
		FR: 'En stock',
		DE: 'Auf Lager',
		NL: 'Op voorraad',
		PL: 'Dostępny',
		TR: 'Stokta var',
		PT: 'Em estoque',
		ES: 'En stock',
		ES_MX: 'En existencia',
		IT: 'Disponibile',
		DA: 'På lager',
		FI: 'Saatavilla',
		SV: 'I lager',
		NO: 'På lager',
		LT: 'Sandėlyje',
		RO: 'Disponibil',
		LV: 'Pieejams',
		EL: 'Διαθέσιμο',
		HU: 'Rendelhető',
		CZ: 'Skladem',
		RU: 'В наличии',
		IS: 'Á lager',
		KO: '재고 있음',
		JA: '在庫あり'
	},
	outOfStock: {
		FR: 'Rupture de stock',
		DE: 'Nicht auf Lager',
		NL: 'Niet op voorraad',
		PL: 'Brak towaru',
		TR: 'Tükendi',
		PT: 'Fora de estoque',
		ES: 'Agotado',
		ES_MX: 'Sin existencia',
		IT: 'Esaurito',
		DA: 'Ikke på lager',
		FI: 'Loppu',
		SV: 'Slut i lager',
		NO: 'Utsolgt',
		LT: 'Išpirkta',
		RO: 'Stoc epuizat',
		LV: 'Nav pieejams',
		EL: 'Εξαντλημένο',
		HU: 'Kifogyott',
		CZ: 'Vyprodáno',
		RU: 'Нет в наличии',
		IS: 'Uppselt',
		KO: '재고 없음',
		JA: '在庫切れ'
	},
	ratingCountLabel: {
		FR: '(#COUNT# avis)',
		DE: '(#COUNT# Bewertungen)',
		NL: '(#COUNT# beoordelingen)',
		PL: '(#COUNT# recenzji)',
		TR: '(#COUNT# inceleme)',
		PT: '(#COUNT# avaliações)',
		ES: '(#COUNT# reseñas)',
		ES_MX: '(#COUNT# opiniones)',
		IT: '(#COUNT# recensioni)',
		DA: '(#COUNT# anmeldelser)',
		FI: '(#COUNT# arvostelua)',
		SV: '(#COUNT# recensioner)',
		NO: '(#COUNT# anmeldelser)',
		LT: '(#COUNT# atsiliepimų)',
		RO: '(#COUNT# recenzii)',
		LV: '(#COUNT# atsauksmes)',
		EL: '(#COUNT# κριτικές)',
		HU: '(#COUNT# értékelés)',
		CZ: '(#COUNT# recenzí)',
		RU: '(#COUNT# отзывов)',
		IS: '(#COUNT# umsagnir)',
		KO: '(#COUNT# 리뷰)',
		JA: '(#COUNT# レビュー)'
	},
	ratingCountLabelSingular: {
		FR: '(1 avis)',
		DE: '(1 Bewertung)',
		NL: '(1 beoordeling)',
		PL: '(1 recenzja)',
		TR: '(1 yorum)',
		PT: '(1 avaliação)',
		ES: '(1 opinión)',
		ES_MX: '(1 opinión)',
		IT: '(1 recensione)',
		DA: '(1 anmeldelse)',
		FI: '(1 arvostelu)',
		SV: '(1 recension)',
		NO: '(1 anmeldelse)',
		LT: '(1 atsiliepimas)',
		RO: '(1 recenzie)',
		LV: '(1 atsauksme)',
		EL: '(1 αξιολόγηση)',
		HU: '(1 vélemény)',
		CZ: '(1 recenze)',
		RU: '(1 отзыв)',
		IS: '(1 umsögn)',
		KO: '(1 리뷰)',
		JA: '(1 件のレビュー)'
	},
	filtersAllLabel: {
		FR: 'Tout',
		DE: 'Alle',
		NL: 'Alles',
		PL: 'Wszystko',
		TR: 'Hepsi',
		PT: 'Tudo',
		ES: 'Todo',
		ES_MX: 'Todo',
		IT: 'Tutto',
		DA: 'Alle',
		FI: 'Kaikki',
		SV: 'Allt',
		NO: 'Alle',
		LT: 'Visi',
		RO: 'Toate',
		LV: 'Visi',
		EL: 'Όλα',
		HU: 'Minden',
		CZ: 'Vše',
		RU: 'Все',
		IS: 'Allt',
		KO: '모두',
		JA: 'すべて'
	},
	searchBoxClearLabel: {
		FR: 'Effacer la saisie de recherche',
		DE: 'Suchfeld löschen',
		NL: 'Zoekinvoer wissen',
		PL: 'Wyczyść pole wyszukiwania',
		TR: 'Arama girişini temizle',
		PT: 'Limpar entrada de pesquisa',
		ES: 'Borrar entrada de búsqueda',
		ES_MX: 'Limpiar entrada de búsqueda',
		IT: 'Pulisci input di ricerca',
		DA: 'Ryd søgefelt',
		FI: 'Tyhjennä hakukenttä',
		SV: 'Rensa sökfält',
		NO: 'Fjern søkeinnhold',
		LT: 'Išvalyti paieškos laukelį',
		RO: 'Ștergeți câmpul de căutare',
		LV: 'Notīrīt meklēšanas ievadi',
		EL: 'Καθαρίστε την αναζήτηση',
		HU: 'Keresési mező törlése',
		CZ: 'Vymazat vyhledávací pole',
		RU: 'Очистить поле поиска',
		IS: 'Tæma leitarfylling',
		KO: '검색 입력 지우기',
		JA: '検索入力をクリア'
	},
	toggleFilterAllLabel: {
		FR: 'Tous les filtres',
		DE: 'Alle Filter',
		NL: 'Alle filters',
		PL: 'Wszystkie filtry',
		TR: 'Tüm filtreler',
		PT: 'Todos os filtros',
		ES: 'Todos los filtros',
		ES_MX: 'Todos los filtros',
		IT: 'Tutti i filtri',
		DA: 'Alle filtre',
		FI: 'Kaikki suodattimet',
		SV: 'Alla filter',
		NO: 'Alle filtre',
		LT: 'Visi filtrai',
		RO: 'Toate filtrele',
		LV: 'Visi filtri',
		EL: 'Όλα τα φίλτρα',
		HU: 'Minden szűrő',
		CZ: 'Všechny filtry',
		RU: 'Все фильтры',
		IS: 'Allar síur',
		KO: '모든 필터',
		JA: 'すべてのフィルター'
	},
	miniPDPTitle: {
		FR: 'Détails du produit',
		DE: 'Produktdetails',
		NL: 'Productdetails',
		PL: 'Szczegóły produktu',
		TR: 'Ürün Detayları',
		PT: 'Detalhes do produto',
		ES: 'Detalles del producto',
		ES_MX: 'Detalles del producto',
		IT: 'Dettagli del prodotto',
		DA: 'Produktdetaljer',
		FI: 'Tuotetiedot',
		SV: 'Produktdetaljer',
		NO: 'Produktdetaljer',
		LT: 'Produkto informacija',
		RO: 'Detalii produs',
		LV: 'Produkta informācija',
		EL: 'Λεπτομέρειες προϊόντος',
		HU: 'Termék részletei',
		CZ: 'Detaily produktu',
		RU: 'Информация о продукте',
		IS: 'Upplýsingar um vöru',
		KO: '제품 세부 정보',
		JA: '製品詳細'
	},
	attributesTitle: {
		FR: 'Spécifications:',
		DE: 'Spezifikationen:',
		NL: 'Specificaties:',
		PL: 'Specyfikacja:',
		TR: 'Teknik Özellikler:',
		PT: 'Especificações:',
		ES: 'Especificaciones:',
		ES_MX: 'Especificaciones:',
		IT: 'Specifiche:',
		DA: 'Specifikationer:',
		FI: 'Tekniset tiedot:',
		SV: 'Specifikationer:',
		NO: 'Spesifikasjoner:',
		LT: 'Specifikacijos:',
		RO: 'Specificații:',
		LV: 'Specifikācijas:',
		EL: 'Προδιαγραφές:',
		HU: 'Műszaki adatok:',
		CZ: 'Specifikace:',
		RU: 'Характеристики:',
		IS: 'Tæknilýsingar:',
		KO: '제품 사양:',
		JA: '仕様:'
	},
	goToProductLabel: {
		FR: 'Aller à la page produit',
		DE: 'Zur Produktseite',
		NL: 'Ga naar productpagina',
		PL: 'Przejdź do strony produktu',
		TR: 'Ürün sayfasına git',
		PT: 'Ir para a página do produto',
		ES: 'Ir a la página del producto',
		ES_MX: 'Ir a la página del producto',
		IT: 'Vai alla pagina del prodotto',
		DA: 'Gå til produktside',
		FI: 'Siirry tuotesivulle',
		SV: 'Gå till produktsidan',
		NO: 'Gå til produktsiden',
		LT: 'Eiti į produkto puslapį',
		RO: 'Mergi la pagina produsului',
		LV: 'Iet uz produkta lapu',
		EL: 'Μετάβαση στη σελίδα προϊόντος',
		HU: 'Ugrás a termékoldalra',
		CZ: 'Přejít na stránku produktu',
		RU: 'Перейти на страницу продукта',
		IS: 'Fara á vörusíðu',
		KO: '제품 페이지로 이동',
		JA: '製品ページへ移動'
	},
	defaultOrderOptionLabel: {
		FR: 'Défaut',
		DE: 'Standard',
		NL: 'Standaard',
		PL: 'Domyślnie',
		TR: 'Varsayılan',
		PT: 'Padrão',
		ES: 'Predeterminado',
		ES_MX: 'Predeterminado',
		IT: 'Predefinito',
		DA: 'Standard',
		FI: 'Oletus',
		SV: 'Standard',
		NO: 'Standard',
		LT: 'Numatytasis',
		RO: 'Implicit',
		LV: 'Noklusējums',
		EL: 'Προεπιλογή',
		HU: 'Alapértelmezett',
		CZ: 'Výchozí',
		RU: 'По умолчанию',
		IS: 'Sjálfgefið',
		KO: '기본값',
		JA: 'デフォルト'
	},
	pageSizeLabel: {
		FR: '#COUNT# par page',
		DE: '#COUNT# pro Seite',
		NL: '#COUNT# per pagina',
		PL: '#COUNT# na stronę',
		TR: 'Sayfa başına #COUNT#',
		PT: '#COUNT# por página',
		ES: '#COUNT# por página',
		ES_MX: '#COUNT# por página',
		IT: '#COUNT# per pagina',
		DA: '#COUNT# pr. side',
		FI: '#COUNT# per sivu',
		SV: '#COUNT# per sida',
		NO: '#COUNT# per side',
		LT: '#COUNT# puslapyje',
		RO: '#COUNT# pe pagină',
		LV: '#COUNT# lapā',
		EL: '#COUNT# ανά σελίδα',
		HU: '#COUNT# oldalanként',
		CZ: '#COUNT# na stránku',
		RU: '#COUNT# на страницу',
		IS: '#COUNT# á síðu',
		KO: '페이지당 #COUNT#',
		JA: '1ページあたり #COUNT#'
	},
	applyAndCloseLabel: {
		FR: 'Appliquer et fermer',
		DE: 'Anwenden und schließen',
		NL: 'Toepassen en sluiten',
		PL: 'Zastosuj i zamknij',
		TR: 'Uygula ve Kapat',
		PT: 'Aplicar e fechar',
		ES: 'Aplicar y cerrar',
		ES_MX: 'Aplicar y cerrar',
		IT: 'Applica e chiudi',
		DA: 'Anvend og luk',
		FI: 'Käytä ja sulje',
		SV: 'Tillämpa och stäng',
		NO: 'Bruk og lukk',
		LT: 'Taikyti ir uždaryti',
		RO: 'Aplică și închide',
		LV: 'Pielietot un aizvērt',
		EL: 'Εφαρμογή και κλείσιμο',
		HU: 'Alkalmaz és bezár',
		CZ: 'Použít a zavřít',
		RU: 'Применить и закрыть',
		IS: 'Nota og loka',
		KO: '적용 및 닫기',
		JA: '適用して閉じる'
	},
	applyButtonLabel: {
		FR: 'Appliquer',
		DE: 'Anwenden',
		NL: 'Toepassen',
		PL: 'Zastosuj',
		TR: 'Uygula',
		PT: 'Aplicar',
		ES: 'Aplicar',
		ES_MX: 'Aplicar',
		IT: 'Applica',
		DA: 'Anvend',
		FI: 'Käytä',
		SV: 'Tillämpa',
		NO: 'Bruk',
		LT: 'Taikyti',
		RO: 'Aplică',
		LV: 'Pielietot',
		EL: 'Εφαρμογή',
		HU: 'Alkalmaz',
		CZ: 'Použít',
		RU: 'Применить',
		IS: 'Nota',
		KO: '적용',
		JA: '適用'
	},
	detailsTab: {
		FR: 'Détails',
		DE: 'Details',
		NL: 'Details',
		PL: 'Szczegóły',
		TR: 'Detaylar',
		PT: 'Detalhes',
		ES: 'Detalles',
		ES_MX: 'Detalles',
		IT: 'Dettagli',
		DA: 'Detaljer',
		FI: 'Tiedot',
		SV: 'Detaljer',
		NO: 'Detaljer',
		LT: 'Informacija',
		RO: 'Detalii',
		LV: 'Detaļas',
		EL: 'Λεπτομέρειες',
		HU: 'Részletek',
		CZ: 'Detaily',
		RU: 'Детали',
		IS: 'Upplýsingar',
		KO: '상세 정보',
		JA: '詳細'
	},
	reviewsTab: {
		FR: 'Avis',
		DE: 'Bewertungen',
		NL: 'Beoordelingen',
		PL: 'Recenzje',
		TR: 'Yorumlar',
		PT: 'Avaliações',
		ES: 'Opiniones',
		ES_MX: 'Opiniones',
		IT: 'Recensioni',
		DA: 'Anmeldelser',
		FI: 'Arvostelut',
		SV: 'Recensioner',
		NO: 'Anmeldelser',
		LT: 'Atsiliepimai',
		RO: 'Recenzii',
		LV: 'Atsauksmes',
		EL: 'Αξιολογήσεις',
		HU: 'Vélemények',
		CZ: 'Recenze',
		RU: 'Отзывы',
		IS: 'Umsagnir',
		KO: '리뷰',
		JA: 'レビュー'
	},
	backToLabel: {
		FR: 'Retour à',
		DE: 'Zurück zu',
		NL: 'Terug naar',
		PL: 'Powrót do',
		TR: 'Geri dön',
		PT: 'Voltar para',
		ES: 'Volver a',
		ES_MX: 'Volver a',
		IT: 'Torna a',
		DA: 'Tilbage til',
		FI: 'Takaisin',
		SV: 'Tillbaka till',
		NO: 'Tilbake til',
		LT: 'Grįžti į',
		RO: 'Înapoi la',
		LV: 'Atpakaļ uz',
		EL: 'Επιστροφή σε',
		HU: 'Vissza a(z)',
		CZ: 'Zpět na',
		RU: 'Назад к',
		IS: 'Til baka í',
		KO: '돌아가기',
		JA: '戻る'
	},
	backToTopLabel: {
		FR: 'Retour en haut',
		DE: 'Zurück nach oben',
		NL: 'Terug naar boven',
		PL: 'Powrót na górę',
		TR: 'Başa dön',
		PT: 'Voltar ao topo',
		ES: 'Volver arriba',
		ES_MX: 'Volver arriba',
		IT: 'Torna su',
		DA: 'Tilbage til toppen',
		FI: 'Takaisin ylös',
		SV: 'Tillbaka till toppen',
		NO: 'Tilbake til toppen',
		LT: 'Grįžti į viršų',
		RO: 'Înapoi sus',
		LV: 'Atpakaļ uz augšu',
		EL: 'Επιστροφή στην κορυφή',
		HU: 'Vissza az elejére',
		CZ: 'Zpět nahoru',
		RU: 'Наверх',
		IS: 'Til baka efst',
		KO: '맨 위로 이동',
		JA: 'トップへ戻る'
	},
	dateFrom: {
		FR: 'De',
		DE: 'Von',
		NL: 'Van',
		PL: 'Od',
		TR: 'Başlangıç',
		PT: 'De',
		ES: 'Desde',
		ES_MX: 'Desde',
		IT: 'Da',
		DA: 'Fra',
		FI: 'Alkaen',
		SV: 'Från',
		NO: 'Fra',
		LT: 'Nuo',
		RO: 'De la',
		LV: 'No',
		EL: 'Από',
		HU: 'Tól',
		CZ: 'Od',
		RU: 'С',
		IS: 'Frá',
		KO: '부터',
		JA: 'から'
	},
	dateTo: {
		FR: 'À',
		DE: 'Bis',
		NL: 'Tot',
		PL: 'Do',
		TR: 'Bitiş',
		PT: 'Até',
		ES: 'Hasta',
		ES_MX: 'Hasta',
		IT: 'A',
		DA: 'Til',
		FI: 'Asti',
		SV: 'Till',
		NO: 'Til',
		LT: 'Iki',
		RO: 'Până la',
		LV: 'Līdz',
		EL: 'Έως',
		HU: 'Ig',
		CZ: 'Do',
		RU: 'До',
		IS: 'Til',
		KO: '까지',
		JA: 'まで'
	},
	picturesTab: {
		FR: 'Images',
		DE: 'Bilder',
		NL: 'Afbeeldingen',
		PL: 'Obrazy',
		TR: 'Resimler',
		PT: 'Imagens',
		ES: 'Imágenes',
		ES_MX: 'Imágenes',
		IT: 'Immagini',
		DA: 'Billeder',
		FI: 'Kuvat',
		SV: 'Bilder',
		NO: 'Bilder',
		LT: 'Nuotraukos',
		RO: 'Imagini',
		LV: 'Attēli',
		EL: 'Εικόνες',
		HU: 'Képek',
		CZ: 'Obrázky',
		RU: 'Картинки',
		IS: 'Myndir',
		KO: '사진',
		JA: '画像'
	},
	miniPDPChatLabel: {
		FR: 'Demander à l\'IA',
		DE: 'KI fragen',
		NL: 'Vraag het AI',
		PL: 'Zapytaj AI',
		TR: 'Yapay Zekaya Sor',
		PT: 'Pergunte à IA',
		ES: 'Preguntar a la IA',
		ES_MX: 'Preguntar a la IA',
		IT: 'Chiedi all\'IA',
		DA: 'Spørg AI',
		FI: 'Kysy tekoälyltä',
		SV: 'Fråga AI',
		NO: 'Spør AI',
		LT: 'Klauskite dirbtinio intelekto',
		RO: 'Întreabă IA',
		LV: 'Jautāt AI',
		EL: 'Ρώτησε την ΤΝ',
		HU: 'Kérdezd az AI-t',
		CZ: 'Zeptejte se AI',
		RU: 'Спросить ИИ',
		IS: 'Spurðu gervigreind',
		KO: 'AI에게 질문하기',
		JA: 'AIに質問する'
	},
	attributeExplanationPrompt: {
		FR: 'Que signifie #ATTRIBUTE# #VALUE# ?',
		DE: 'Was bedeutet #ATTRIBUTE# #VALUE#?',
		NL: 'Wat betekent #ATTRIBUTE# #VALUE#?',
		PL: 'Co oznacza #ATTRIBUTE# #VALUE#?',
		TR: '#ATTRIBUTE# #VALUE# ne anlama geliyor?',
		PT: 'O que significa #ATTRIBUTE# #VALUE#?',
		ES: '¿Qué significa #ATTRIBUTE# #VALUE#?',
		ES_MX: '¿Qué significa #ATTRIBUTE# #VALUE#?',
		IT: 'Cosa significa #ATTRIBUTE# #VALUE#?',
		DA: 'Hvad betyder #ATTRIBUTE# #VALUE#?',
		FI: 'Mitä tarkoittaa #ATTRIBUTE# #VALUE#?',
		SV: 'Vad betyder #ATTRIBUTE# #VALUE#?',
		NO: 'Hva betyr #ATTRIBUTE# #VALUE#?',
		LT: 'Ką reiškia #ATTRIBUTE# #VALUE#?',
		RO: 'Ce înseamnă #ATTRIBUTE# #VALUE#?',
		LV: 'Ko nozīmē #ATTRIBUTE# #VALUE#?',
		EL: 'Τι σημαίνει #ATTRIBUTE# #VALUE#;',
		HU: 'Mit jelent #ATTRIBUTE# #VALUE#?',
		CZ: 'Co znamená #ATTRIBUTE# #VALUE#?',
		RU: 'Что означает #ATTRIBUTE# #VALUE#?',
		IS: 'Hvað þýðir #ATTRIBUTE# #VALUE#?',
		KO: '#ATTRIBUTE# #VALUE#는 무엇을 의미하나요?',
		JA: '#ATTRIBUTE# #VALUE# はどういう意味ですか？'
	},
	guidedQuestionBackLabel: {
		FR: 'Retour',
		DE: 'Zurück',
		NL: 'Terug',
		PL: 'Wstecz',
		TR: 'Geri',
		PT: 'Voltar',
		ES: 'Atrás',
		ES_MX: 'Atrás',
		IT: 'Indietro',
		DA: 'Tilbage',
		FI: 'Takaisin',
		SV: 'Tillbaka',
		NO: 'Tilbake',
		LT: 'Atgal',
		RO: 'Înapoi',
		LV: 'Atpakaļ',
		EL: 'Πίσω',
		HU: 'Vissza',
		CZ: 'Zpět',
		RU: 'Назад',
		IS: 'Til baka',
		KO: '뒤로',
		JA: '戻る'
	},
	guidedQuestionSkipLabel: {
		FR: 'Ignorer',
		DE: 'Überspringen',
		NL: 'Overslaan',
		PL: 'Pomiń',
		TR: 'Atla',
		PT: 'Pular',
		ES: 'Omitir',
		ES_MX: 'Omitir',
		IT: 'Salta',
		DA: 'Spring over',
		FI: 'Ohita',
		SV: 'Hoppa över',
		NO: 'Hopp over',
		LT: 'Praleisti',
		RO: 'Sari peste',
		LV: 'Izlaist',
		EL: 'Παράλειψη',
		HU: 'Kihagyás',
		CZ: 'Přeskočit',
		RU: 'Пропустить',
		IS: 'Sleppa',
		KO: '건너뛰기',
		JA: 'スキップ'
	},
	multiSelectShowLessAriaLabel: {
		FR: 'Voir moins d’options #FILTER_NAME#',
		DE: 'Weniger #FILTER_NAME#-Optionen anzeigen',
		NL: 'Minder #FILTER_NAME#-opties weergeven',
		PL: 'Zobacz mniej opcji #FILTER_NAME#',
		TR: 'Daha az #FILTER_NAME# seçeneğini gör',
		PT: 'Ver menos opções de #FILTER_NAME#',
		ES: 'Ver menos opciones de #FILTER_NAME#',
		ES_MX: 'Ver menos opciones de #FILTER_NAME#',
		IT: 'Vedi meno opzioni #FILTER_NAME#',
		DA: 'Se færre #FILTER_NAME#-muligheder',
		FI: 'Näytä vähemmän #FILTER_NAME#-vaihtoehtoja',
		SV: 'Visa färre #FILTER_NAME#-alternativ',
		NO: 'Vis færre #FILTER_NAME#-alternativer',
		LT: 'Rodyti mažiau #FILTER_NAME# parinkčių',
		RO: 'Vezi mai puține opțiuni #FILTER_NAME#',
		LV: 'Rādīt mazāk #FILTER_NAME# opcijas',
		EL: 'Δείτε λιγότερες επιλογές #FILTER_NAME#',
		HU: 'Kevesebb #FILTER_NAME# opció megjelenítése',
		CZ: 'Zobrazit méně možností #FILTER_NAME#',
		RU: 'Показать меньше вариантов #FILTER_NAME#',
		IS: 'Sýna færri #FILTER_NAME# valkosti',
		KO: '#FILTER_NAME# 옵션 더 적게 보기',
		JA: '#FILTER_NAME# のオプションを減らす'
	},
	multiSelectShowMoreAriaLabel: {
		FR: 'Voir #COUNT# options #FILTER_NAME# supplémentaires',
		DE: '#COUNT# weitere #FILTER_NAME#-Optionen anzeigen',
		NL: 'Toon #COUNT# extra #FILTER_NAME#-opties',
		PL: 'Zobacz kolejne #COUNT# opcje #FILTER_NAME#',
		TR: '#COUNT# tane daha #FILTER_NAME# seçeneğini gör',
		PT: 'Ver mais #COUNT# opções de #FILTER_NAME#',
		ES: 'Ver #COUNT# más opciones de #FILTER_NAME#',
		ES_MX: 'Ver #COUNT# más opciones de #FILTER_NAME#',
		IT: 'Vedi altre #COUNT# opzioni #FILTER_NAME#',
		DA: 'Se #COUNT# flere #FILTER_NAME#-muligheder',
		FI: 'Näytä #COUNT# lisää #FILTER_NAME#-vaihtoehtoja',
		SV: 'Visa #COUNT# fler #FILTER_NAME#-alternativ',
		NO: 'Vis #COUNT# flere #FILTER_NAME#-alternativer',
		LT: 'Rodyti dar #COUNT# #FILTER_NAME# parinktis',
		RO: 'Vezi încă #COUNT# opțiuni #FILTER_NAME#',
		LV: 'Rādīt vēl #COUNT# #FILTER_NAME# opcijas',
		EL: 'Δείτε ακόμα #COUNT# επιλογές #FILTER_NAME#',
		HU: 'További #COUNT# #FILTER_NAME# opció megjelenítése',
		CZ: 'Zobrazit dalších #COUNT# možností #FILTER_NAME#',
		RU: 'Показать ещё #COUNT# вариантов #FILTER_NAME#',
		IS: 'Sýna #COUNT# fleiri #FILTER_NAME# valkosti',
		KO: '#FILTER_NAME# 옵션 #COUNT#개 더 보기',
		JA: '#FILTER_NAME# のオプションをさらに #COUNT# 件表示'
	},
	clearGroupAriaLabel: {
		FR: 'Effacer les options du groupe de filtres #FILTER_NAME#',
		DE: '#FILTER_NAME#-Filtergruppe zurücksetzen',
		NL: 'Groepsopties voor #FILTER_NAME# wissen',
		PL: 'Wyczyść opcje grupy filtra #FILTER_NAME#',
		TR: '#FILTER_NAME# filtre grubunu temizle',
		PT: 'Limpar opções do grupo de filtros #FILTER_NAME#',
		ES: 'Borrar opciones del grupo de filtros #FILTER_NAME#',
		ES_MX: 'Borrar opciones del grupo de filtros #FILTER_NAME#',
		IT: 'Cancella le opzioni del gruppo filtro #FILTER_NAME#',
		DA: 'Ryd #FILTER_NAME# filtergruppemuligheder',
		FI: 'Tyhjennä #FILTER_NAME#-suodatinryhmän vaihtoehdot',
		SV: 'Rensa #FILTER_NAME# filtergruppsalternativ',
		NO: 'Fjern #FILTER_NAME# filtergruppevalg',
		LT: 'Išvalyti #FILTER_NAME# filtro grupės parinktis',
		RO: 'Șterge opțiunile grupului de filtre #FILTER_NAME#',
		LV: 'Notīrīt #FILTER_NAME# filtra grupas opcijas',
		EL: 'Εκκαθάριση επιλογών ομάδας φίλτρων #FILTER_NAME#',
		HU: '#FILTER_NAME# szűrőcsoport törlése',
		CZ: 'Vymazat možnosti skupiny filtru #FILTER_NAME#',
		RU: 'Очистить группу фильтров #FILTER_NAME#',
		IS: 'Hreinsa #FILTER_NAME# síuhópvalkosti',
		KO: '#FILTER_NAME# 필터 그룹 옵션 지우기',
		JA: '#FILTER_NAME# フィルターグループのオプションをクリア'
	},
	skipFilterGroupAriaLabel: {
		FR: 'Ignorer le groupe de filtres #FILTER_NAME#',
		DE: '#FILTER_NAME#-Filtergruppe überspringen',
		NL: 'Sla #FILTER_NAME#-filtergroep over',
		PL: 'Pomiń grupę filtra #FILTER_NAME#',
		TR: '#FILTER_NAME# filtre grubunu atla',
		PT: 'Ignorar grupo de filtros #FILTER_NAME#',
		ES: 'Omitir grupo de filtros #FILTER_NAME#',
		ES_MX: 'Omitir grupo de filtros #FILTER_NAME#',
		IT: 'Salta il gruppo filtro #FILTER_NAME#',
		DA: 'Spring #FILTER_NAME# filtergruppe over',
		FI: 'Ohita #FILTER_NAME#-suodatinryhmä',
		SV: 'Hoppa över #FILTER_NAME# filtergrupp',
		NO: 'Hopp over #FILTER_NAME# filtergruppe',
		LT: 'Praleisti #FILTER_NAME# filtro grupę',
		RO: 'Sari peste grupul de filtre #FILTER_NAME#',
		LV: 'Izlaist #FILTER_NAME# filtru grupu',
		EL: 'Παράλειψη ομάδας φίλτρων #FILTER_NAME#',
		HU: '#FILTER_NAME# szűrőcsoport kihagyása',
		CZ: 'Přeskočit skupinu filtru #FILTER_NAME#',
		RU: 'Пропустить группу фильтров #FILTER_NAME#',
		IS: 'Sleppa #FILTER_NAME# síuhóp',
		KO: '#FILTER_NAME# 필터 그룹 건너뛰기',
		JA: '#FILTER_NAME# フィルターグループをスキップ'
	},
	countAriaLabel: {
		FR: '#COUNT# résultats disponibles',
		DE: '#COUNT# Ergebnisse verfügbar',
		NL: '#COUNT# resultaten beschikbaar',
		PL: 'Dostępne wyniki: #COUNT#',
		TR: '#COUNT# sonuç mevcut',
		PT: '#COUNT# resultados disponíveis',
		ES: '#COUNT# resultados disponibles',
		ES_MX: '#COUNT# resultados disponibles',
		IT: '#COUNT# risultati disponibili',
		DA: '#COUNT# resultater tilgængelige',
		FI: '#COUNT# tulosta saatavilla',
		SV: '#COUNT# resultat tillgängliga',
		NO: '#COUNT# resultater tilgjengelige',
		LT: 'Yra #COUNT# rezultatų',
		RO: '#COUNT# rezultate disponibile',
		LV: '#COUNT# pieejami rezultāti',
		EL: 'Διαθέσιμα #COUNT# αποτελέσματα',
		HU: '#COUNT# találat érhető el',
		CZ: 'K dispozici #COUNT# výsledků',
		RU: 'Доступно #COUNT# результатов',
		IS: '#COUNT# niðurstöður í boði',
		KO: '#COUNT#개의 결과 이용 가능',
		JA: '#COUNT# 件の結果があります'
	},
	    sliderMinUnitAriaLabel: {
		FR: 'Min #FILTER_NAME# en #UNIT#',
		DE: 'Min #FILTER_NAME# in #UNIT#',
		NL: 'Min #FILTER_NAME# in #UNIT#',
		PL: 'Min #FILTER_NAME# w #UNIT#',
		TR: 'En az #FILTER_NAME# #UNIT#',
		PT: 'Mín #FILTER_NAME# em #UNIT#',
		ES: 'Mín #FILTER_NAME# en #UNIT#',
		ES_MX: 'Mín #FILTER_NAME# en #UNIT#',
		IT: 'Min #FILTER_NAME# in #UNIT#',
		DA: 'Min #FILTER_NAME# i #UNIT#',
		FI: 'Pienin #FILTER_NAME# #UNIT#',
		SV: 'Min #FILTER_NAME# i #UNIT#',
		NO: 'Min #FILTER_NAME# i #UNIT#',
		LT: 'Min #FILTER_NAME# #UNIT#',
		RO: 'Min #FILTER_NAME# în #UNIT#',
		LV: 'Min #FILTER_NAME# #UNIT#',
		EL: 'Ελάχιστο #FILTER_NAME# σε #UNIT#',
		HU: 'Min #FILTER_NAME# #UNIT#',
		CZ: 'Min #FILTER_NAME# v #UNIT#',
		RU: 'Мин. #FILTER_NAME# в #UNIT#',
		IS: 'Lágmarks #FILTER_NAME# í #UNIT#',
		KO: '#FILTER_NAME# 최소 #UNIT#',
		JA: '最小 #FILTER_NAME# #UNIT#'
	},
	sliderMaxUnitAriaLabel: {
		FR: 'Max #FILTER_NAME# en #UNIT#',
		DE: 'Max #FILTER_NAME# in #UNIT#',
		NL: 'Max #FILTER_NAME# in #UNIT#',
		PL: 'Max #FILTER_NAME# w #UNIT#',
		TR: 'En çok #FILTER_NAME# #UNIT#',
		PT: 'Máx #FILTER_NAME# em #UNIT#',
		ES: 'Máx #FILTER_NAME# en #UNIT#',
		ES_MX: 'Máx #FILTER_NAME# en #UNIT#',
		IT: 'Max #FILTER_NAME# in #UNIT#',
		DA: 'Max #FILTER_NAME# i #UNIT#',
		FI: 'Suurin #FILTER_NAME# #UNIT#',
		SV: 'Max #FILTER_NAME# i #UNIT#',
		NO: 'Maks #FILTER_NAME# i #UNIT#',
		LT: 'Maks #FILTER_NAME# #UNIT#',
		RO: 'Max #FILTER_NAME# în #UNIT#',
		LV: 'Maks #FILTER_NAME# #UNIT#',
		EL: 'Μέγιστο #FILTER_NAME# σε #UNIT#',
		HU: 'Max #FILTER_NAME# #UNIT#',
		CZ: 'Max #FILTER_NAME# v #UNIT#',
		RU: 'Макс. #FILTER_NAME# в #UNIT#',
		IS: 'Hámarks #FILTER_NAME# í #UNIT#',
		KO: '#FILTER_NAME# 최대 #UNIT#',
		JA: '最大 #FILTER_NAME# #UNIT#'
	},
	applyFilterAriaLabel: {
		FR: 'Appliquer le filtre #FILTER_NAME#',
		DE: '#FILTER_NAME#-Filter anwenden',
		NL: 'Filter #FILTER_NAME# toepassen',
		PL: 'Zastosuj filtr #FILTER_NAME#',
		TR: '#FILTER_NAME# filtresini uygula',
		PT: 'Aplicar filtro #FILTER_NAME#',
		ES: 'Aplicar filtro #FILTER_NAME#',
		ES_MX: 'Aplicar filtro #FILTER_NAME#',
		IT: 'Applica filtro #FILTER_NAME#',
		DA: 'Anvend #FILTER_NAME# filter',
		FI: 'Käytä #FILTER_NAME#-suodatinta',
		SV: 'Använd #FILTER_NAME#-filter',
		NO: 'Bruk #FILTER_NAME#-filter',
		LT: 'Taikyti #FILTER_NAME# filtrą',
		RO: 'Aplică filtrul #FILTER_NAME#',
		LV: 'Lietot #FILTER_NAME# filtru',
		EL: 'Εφαρμογή φίλτρου #FILTER_NAME#',
		HU: '#FILTER_NAME# szűrő alkalmazása',
		CZ: 'Použít filtr #FILTER_NAME#',
		RU: 'Применить фильтр #FILTER_NAME#',
		IS: 'Virkja #FILTER_NAME# síu',
		KO: '#FILTER_NAME# 필터 적용',
		JA: '#FILTER_NAME# フィルターを適用'
	},
	 sliderControlDescription: {
		FR: 'Utilisez les flèches pour ajuster les valeurs du curseur ou saisissez directement les nombres dans les champs ci-dessous.',
		DE: 'Verwenden Sie die Pfeiltasten, um die Schieberegler-Werte anzupassen, oder geben Sie die Zahlen direkt in die Felder unten ein.',
		NL: 'Gebruik de pijltjestoetsen om de schuifwaarden aan te passen of typ de cijfers direct in de onderstaande velden.',
		PL: 'Użyj klawiszy strzałek, aby dostosować wartości suwaka lub wpisz liczby bezpośrednio w polach poniżej.',
		TR: 'Kaydırıcı değerlerini ayarlamak için ok tuşlarını kullanın ya da aşağıdaki alanlara doğrudan sayıları girin.',
		PT: 'Use as teclas de seta para ajustar os valores do controle deslizante ou digite os números diretamente nos campos abaixo.',
		ES: 'Utiliza las teclas de flecha para ajustar los valores del control deslizante o escribe los números directamente en los campos de abajo.',
		ES_MX: 'Usa las teclas de flecha para ajustar los valores del control deslizante o escribe los números directamente en los campos de abajo.',
		IT: 'Usa i tasti freccia per regolare i valori del cursore o digita i numeri direttamente nei campi sottostanti.',
		DA: 'Brug piletasterne til at justere skyderens værdier, eller indtast tal direkte i felterne nedenfor.',
		FI: 'Käytä nuolinäppäimiä liukusäätimen arvojen muuttamiseen tai kirjoita numerot suoraan alla oleviin kenttiin.',
		SV: 'Använd piltangenterna för att justera reglagets värden eller skriv siffror direkt i fälten nedan.',
		NO: 'Bruk piltastene for å justere glidebryterens verdier, eller skriv tall direkte i feltene under.',
		LT: 'Naudokite rodyklių klavišus, kad sureguliuotumėte slankiklio reikšmes, arba įveskite skaičius tiesiai į laukus apačioje.',
		RO: 'Folosiți tastele săgeată pentru a ajusta valorile cursorului sau introduceți direct numerele în câmpurile de mai jos.',
		LV: 'Lai pielāgotu slīdņa vērtības, izmantojiet bulttaustiņus vai ievadiet skaitļus tieši zemāk esošajos laukos.',
		EL: 'Χρησιμοποιήστε τα πλήκτρα βέλους για να ρυθμίσετε τις τιμές του ολισθητήρα ή πληκτρολογήστε απευθείας τους αριθμούς στα πεδία παρακάτω.',
		HU: 'A csúszka értékeinek módosításához használja a nyílbillentyűket, vagy írja be a számokat közvetlenül az alábbi mezőkbe.',
		CZ: 'Použijte šipky k úpravě hodnot posuvníku nebo zadejte čísla přímo do polí níže.',
		RU: 'Используйте клавиши со стрелками для настройки значений ползунка или введите числа напрямую в поля ниже.',
		IS: 'Notaðu örvalykla til að stilla gildin á sleðanum eða sláðu inn tölur beint í reitina hér fyrir neðan.',
		KO: '화살표 키를 사용하여 슬라이더 값을 조정하거나 아래 입력란에 숫자를 직접 입력하세요.',
		JA: '矢印キーでスライダーの値を調整するか、下の入力欄に直接数字を入力してください。'
	},
	changeDisplayTypeLabel: {
        FR: 'Changer le type d’affichage',
        DE: 'Anzeigeart ändern',
        NL: 'Weergavetype wijzigen',
        PL: 'Zmień typ wyświetlania',
        TR: 'Görüntü türünü değiştir',
        PT: 'Alterar tipo de exibição',
        ES: 'Cambiar tipo de visualización',
        ES_MX: 'Cambiar tipo de visualización',
        IT: 'Cambia tipo di visualizzazione',
        DA: 'Skift visningstype',
        FI: 'Vaihda näyttötyyppiä',
        SV: 'Byt visningstyp',
        NO: 'Endre visningstype',
        LT: 'Keisti rodymo tipą',
        RO: 'Schimbă tipul de afișare',
        LV: 'Mainīt attēlošanas veidu',
        EL: 'Αλλαγή τύπου προβολής',
        HU: 'Nézettípus módosítása',
        CZ: 'Změnit typ zobrazení',
        RU: 'Изменить тип отображения',
        IS: 'Breyta birtingargerð',
        KO: '표시 유형 변경',
        JA: '表示タイプを変更'
    },
	 filterCloseButtonAriaLabel: {
        FR: 'Fermer le filtre',
        DE: 'Filter schließen',
        NL: 'Filter sluiten',
        PL: 'Zamknij filtr',
        TR: 'Filtreyi kapat',
        PT: 'Fechar filtro',
        ES: 'Cerrar filtro',
        ES_MX: 'Cerrar filtro',
        IT: 'Chiudi filtro',
        DA: 'Luk filter',
        FI: 'Sulje suodatin',
        SV: 'Stäng filter',
        NO: 'Lukk filter',
        LT: 'Uždaryti filtrą',
        RO: 'Închide filtrul',
        LV: 'Aizvērt filtru',
        EL: 'Κλείσιμο φίλτρου',
        HU: 'Szűrő bezárása',
        CZ: 'Zavřít filtr',
        RU: 'Закрыть фильтр',
        IS: 'Loka síu',
        KO: '필터 닫기',
        JA: 'フィルターを閉じる'
    },
    miniPDPCloseButtonAriaLabel: {
        FR: 'Fermer les détails du produit',
        DE: 'Produktdetails schließen',
        NL: 'Productdetails sluiten',
        PL: 'Zamknij szczegóły produktu',
        TR: 'Ürün detaylarını kapat',
        PT: 'Fechar detalhes do produto',
        ES: 'Cerrar detalles del producto',
        ES_MX: 'Cerrar detalles del producto',
        IT: 'Chiudi dettagli prodotto',
        DA: 'Luk produktdetaljer',
        FI: 'Sulje tuotetiedot',
        SV: 'Stäng produktdetaljer',
        NO: 'Lukk produktdetaljer',
        LT: 'Uždaryti produkto informaciją',
        RO: 'Închide detaliile produsului',
        LV: 'Aizvērt produkta informāciju',
        EL: 'Κλείσιμο λεπτομερειών προϊόντος',
        HU: 'Termékrészletek bezárása',
        CZ: 'Zavřít detaily produktu',
        RU: 'Закрыть информацию о продукте',
        IS: 'Loka vöruskilgreiningu',
        KO: '제품 세부정보 닫기',
        JA: '商品詳細を閉じる'
    },
    zoeCloseButtonAriaLabel: {
        FR: 'Fermer le chat',
        DE: 'Chat schließen',
        NL: 'Chat sluiten',
        PL: 'Zamknij czat',
        TR: 'Sohbeti kapat',
        PT: 'Fechar chat',
        ES: 'Cerrar chat',
        ES_MX: 'Cerrar chat',
        IT: 'Chiudi chat',
        DA: 'Luk chat',
        FI: 'Sulje chat',
        SV: 'Stäng chat',
        NO: 'Lukk chat',
        LT: 'Uždaryti pokalbį',
        RO: 'Închide chatul',
        LV: 'Aizvērt tērzēšanu',
        EL: 'Κλείσιμο συνομιλίας',
        HU: 'Csevegés bezárása',
        CZ: 'Zavřít chat',
        RU: 'Закрыть чат',
        IS: 'Loka spjalli',
        KO: '채팅 닫기',
        JA: 'チャットを閉じる'
    },
	 resultsCloseButtonAriaLabel: {
        FR: 'Fermer le résultat de recherche',
        DE: 'Suchergebnis schließen',
        NL: 'Zoekresultaat sluiten',
        PL: 'Zamknij wynik wyszukiwania',
        TR: 'Arama sonucunu kapat',
        PT: 'Fechar resultado da pesquisa',
        ES: 'Cerrar resultado de búsqueda',
        ES_MX: 'Cerrar resultado de búsqueda',
        IT: 'Chiudi risultato di ricerca',
        DA: 'Luk søgeresultat',
        FI: 'Sulje hakutulos',
        SV: 'Stäng sökresultat',
        NO: 'Lukk søkeresultat',
        LT: 'Uždaryti paieškos rezultatą',
        RO: 'Închide rezultatul căutării',
        LV: 'Aizvērt meklēšanas rezultātu',
        EL: 'Κλείσιμο αποτελέσματος αναζήτησης',
        HU: 'Keresési találat bezárása',
        CZ: 'Zavřít výsledek hledání',
        RU: 'Закрыть результат поиска',
        IS: 'Loka leitarniðurstöðu',
        KO: '검색 결과 닫기',
        JA: '検索結果を閉じる'
    },
	 removeAriaLabel: {
        FR: 'Retirer #PRODUCT_NAME# de la comparaison',
        DE: '#PRODUCT_NAME# aus dem Vergleich entfernen',
        NL: '#PRODUCT_NAME# uit vergelijking verwijderen',
        PL: 'Usuń #PRODUCT_NAME# z porównania',
        TR: '#PRODUCT_NAME# karşılaştırmadan kaldır',
        PT: 'Remover #PRODUCT_NAME# da comparação',
        ES: 'Eliminar #PRODUCT_NAME# de la comparación',
        ES_MX: 'Eliminar #PRODUCT_NAME# de la comparación',
        IT: 'Rimuovi #PRODUCT_NAME# dal confronto',
        DA: 'Fjern #PRODUCT_NAME# fra sammenligning',
        FI: 'Poista #PRODUCT_NAME# vertailusta',
        SV: 'Ta bort #PRODUCT_NAME# från jämförelsen',
        NO: 'Fjern #PRODUCT_NAME# fra sammenligning',
        LT: 'Pašalinti #PRODUCT_NAME# iš palyginimo',
        RO: 'Elimină #PRODUCT_NAME# din comparație',
        LV: 'Noņemt #PRODUCT_NAME# no salīdzināšanas',
        EL: 'Αφαίρεση του #PRODUCT_NAME# από τη σύγκριση',
        HU: '#PRODUCT_NAME# eltávolítása az összehasonlításból',
        CZ: 'Odebrat #PRODUCT_NAME# z porovnání',
        RU: 'Удалить #PRODUCT_NAME# из сравнения',
        IS: 'Fjarlægja #PRODUCT_NAME# úr samanburði',
        KO: '#PRODUCT_NAME# 비교에서 제거',
        JA: '#PRODUCT_NAME# を比較から削除'
    },
    regionAriaLabel: {
        FR: 'Produits comparés',
        DE: 'Verglichene Produkte',
        NL: 'Vergeleken producten',
        PL: 'Porównywane produkty',
        TR: 'Karşılaştırılan ürünler',
        PT: 'Produtos comparados',
        ES: 'Productos comparados',
        ES_MX: 'Productos comparados',
        IT: 'Prodotti confrontati',
        DA: 'Sammenlignede produkter',
        FI: 'Verratut tuotteet',
        SV: 'Jämförda produkter',
        NO: 'Sammenlignede produkter',
        LT: 'Palyginti produktai',
        RO: 'Produse comparate',
        LV: 'Salīdzinātie produkti',
        EL: 'Συγκρινόμενα προϊόντα',
        HU: 'Összehasonlított termékek',
        CZ: 'Porovnávané produkty',
        RU: 'Сравниваемые товары',
        IS: 'Borið saman vörur',
        KO: '비교된 제품',
        JA: '比較した商品'
    },
	 clearRangeFilterAriaLabel: {
        FR: 'Effacer le filtre #FILTER_NAME#',
        DE: '#FILTER_NAME#-Filter entfernen',
        NL: '#FILTER_NAME#-filter wissen',
        PL: 'Wyczyść filtr #FILTER_NAME#',
        TR: '#FILTER_NAME# filtresini temizle',
        PT: 'Limpar filtro #FILTER_NAME#',
        ES: 'Borrar filtro #FILTER_NAME#',
        ES_MX: 'Borrar filtro #FILTER_NAME#',
        IT: 'Cancella filtro #FILTER_NAME#',
        DA: 'Ryd #FILTER_NAME# filter',
        FI: 'Tyhjennä #FILTER_NAME#-suodatin',
        SV: 'Rensa #FILTER_NAME#-filter',
        NO: 'Fjern #FILTER_NAME#-filter',
        LT: 'Išvalyti #FILTER_NAME# filtrą',
        RO: 'Șterge filtrul #FILTER_NAME#',
        LV: 'Notīrīt #FILTER_NAME# filtru',
        EL: 'Εκκαθάριση φίλτρου #FILTER_NAME#',
        HU: '#FILTER_NAME# szűrő törlése',
        CZ: 'Vymazat filtr #FILTER_NAME#',
        RU: 'Очистить фильтр #FILTER_NAME#',
        IS: 'Hreinsa #FILTER_NAME# síu',
        KO: '#FILTER_NAME# 필터 지우기',
        JA: '#FILTER_NAME# フィルターをクリア'
    },
    clearMultipleChoiceFilterAriaLabel: {
        FR: 'Retirer #OPTION_NAME# du filtre #FILTER_NAME#',
        DE: '#OPTION_NAME# aus dem #FILTER_NAME#-Filter entfernen',
        NL: '#OPTION_NAME# uit #FILTER_NAME#-filter verwijderen',
        PL: 'Usuń #OPTION_NAME# z filtra #FILTER_NAME#',
        TR: '#FILTER_NAME# filtresinden #OPTION_NAME# kaldır',
        PT: 'Remover #OPTION_NAME# do filtro #FILTER_NAME#',
        ES: 'Eliminar #OPTION_NAME# del filtro #FILTER_NAME#',
        ES_MX: 'Eliminar #OPTION_NAME# del filtro #FILTER_NAME#',
        IT: 'Rimuovi #OPTION_NAME# dal filtro #FILTER_NAME#',
        DA: 'Fjern #OPTION_NAME# fra #FILTER_NAME# filter',
        FI: 'Poista #OPTION_NAME# #FILTER_NAME#-suodattimesta',
        SV: 'Ta bort #OPTION_NAME# från #FILTER_NAME#-filtret',
        NO: 'Fjern #OPTION_NAME# fra #FILTER_NAME#-filteret',
        LT: 'Pašalinti #OPTION_NAME# iš #FILTER_NAME# filtro',
        RO: 'Elimină #OPTION_NAME# din filtrul #FILTER_NAME#',
        LV: 'Noņemt #OPTION_NAME# no #FILTER_NAME# filtra',
        EL: 'Αφαίρεση του #OPTION_NAME# από το φίλτρο #FILTER_NAME#',
        HU: '#OPTION_NAME# eltávolítása a #FILTER_NAME# szűrőből',
        CZ: 'Odebrat #OPTION_NAME# z filtru #FILTER_NAME#',
        RU: 'Удалить #OPTION_NAME# из фильтра #FILTER_NAME#',
        IS: 'Fjarlægja #OPTION_NAME# úr #FILTER_NAME# síu',
        KO: '#FILTER_NAME# 필터에서 #OPTION_NAME# 제거',
        JA: '#FILTER_NAME# フィルターから #OPTION_NAME# を削除'
    }
};

const res = {
	FR,
	DE,
	NL,
	PL,
	TR,
	PT,
	ES,
	ES_MX,
	IT,
	DA,
	FI,
	SV,
	NO,
	LT,
	RO,
	LV,
	EL,
	HU,
	CZ,
	RU,
	IS,
	KO,
	JA
};

Object.keys(additionalTranslations.variantsLabel).forEach((lang) => {
	const obj = res[lang];
	if (obj) {
		obj.results = obj.results || {};
		obj.results.variantsLabel = additionalTranslations.variantsLabel[lang];
		obj.results.addToCartLabel = additionalTranslations.addToCartLabel[lang];
		obj.results.inStockLabel = additionalTranslations.inStock[lang];
		obj.results.outOfStockLabel = additionalTranslations.outOfStock[lang];
		obj.results.ratingCountLabel = additionalTranslations.ratingCountLabel[lang];
		obj.results.ratingCountLabelSingular = additionalTranslations.ratingCountLabelSingular[lang];
		obj.results.defaultOrderOptionLabel = additionalTranslations.defaultOrderOptionLabel[lang];
		obj.results.pageSizeLabel = additionalTranslations.pageSizeLabel[lang];
		obj.results.backToTopLabel = additionalTranslations.backToTopLabel[lang];
		obj.results.guidedQuestionBackLabel = additionalTranslations.guidedQuestionBackLabel[lang];
		obj.results.guidedQuestionSkipLabel = additionalTranslations.guidedQuestionSkipLabel[lang];
		obj.results.changeDisplayTypeLabel = additionalTranslations.changeDisplayTypeLabel[lang];
		obj.results.closeButtonAriaLabel = additionalTranslations.resultsCloseButtonAriaLabel[lang];
	}
});

Object.keys(additionalTranslations.filtersAllLabel).forEach((lang) => {
	const obj = res[lang];
	if (obj) {
		obj.filters = obj.filters || {};
		obj.filters.allLabel = additionalTranslations.filtersAllLabel[lang];
		obj.filters.toggleAllButtonLabel = additionalTranslations.toggleFilterAllLabel[lang];
		obj.filters.applyAndCloseLabel = additionalTranslations.applyAndCloseLabel[lang];
		obj.filters.applyButtonLabel = additionalTranslations.applyButtonLabel[lang];
		obj.filters.dateFrom = additionalTranslations.dateFrom[lang];
		obj.filters.dateTo = additionalTranslations.dateTo[lang];
		obj.filters.clearGroupAriaLabel = additionalTranslations.clearGroupAriaLabel[lang];
		obj.filters.skipFilterGroupAriaLabel = additionalTranslations.skipFilterGroupAriaLabel[lang];
		obj.filters.countAriaLabel = additionalTranslations.countAriaLabel[lang];
		obj.filters.multiSelectShowLessAriaLabel = additionalTranslations.multiSelectShowLessAriaLabel[lang];
		obj.filters.multiSelectShowMoreAriaLabel = additionalTranslations.multiSelectShowMoreAriaLabel[lang];
		obj.filters.sliderMinUnitAriaLabel = additionalTranslations.sliderMinUnitAriaLabel[lang];
		obj.filters.sliderMaxUnitAriaLabel = additionalTranslations.sliderMaxUnitAriaLabel[lang];
		obj.filters.applyFilterAriaLabel = additionalTranslations.applyFilterAriaLabel[lang];
		obj.filters.sliderControlDescription = additionalTranslations.sliderControlDescription[lang];
		obj.filters.closeButtonAriaLabel = additionalTranslations.filterCloseButtonAriaLabel[lang];
		obj.filters.clearRangeFilterAriaLabel = additionalTranslations.clearRangeFilterAriaLabel[lang];
		obj.filters.clearMultipleChoiceFilterAriaLabel = additionalTranslations.clearMultipleChoiceFilterAriaLabel[lang];
	}
});

Object.keys(additionalTranslations.searchBoxClearLabel).forEach((lang) => {
	const obj = res[lang];
	if (obj) {
		obj.searchBox = obj.searchBox || {};
		obj.searchBox.clearLabel = additionalTranslations.searchBoxClearLabel[lang];
	}
});

Object.keys(additionalTranslations.miniPDPTitle).forEach((lang) => {
	const obj = res[lang];
	if (obj) {
		obj.miniPDP = obj.miniPDP || {};
		obj.miniPDP.title = additionalTranslations.miniPDPTitle[lang];
		obj.miniPDP.attributesTitle = additionalTranslations.attributesTitle[lang];
		obj.miniPDP.goToProductLabel = additionalTranslations.goToProductLabel[lang];
		obj.miniPDP.detailsTab = additionalTranslations.detailsTab[lang];
		obj.miniPDP.reviewsTab = additionalTranslations.reviewsTab[lang];
		obj.miniPDP.picturesTab = additionalTranslations.picturesTab[lang];
		obj.miniPDP.backToLabel = additionalTranslations.backToLabel[lang];
		obj.miniPDP.chatLabel = additionalTranslations.miniPDPChatLabel[lang];
		obj.miniPDP.attributeExplanationPrompt = additionalTranslations.attributeExplanationPrompt[lang];
		obj.miniPDP.closeButtonAriaLabel = additionalTranslations.miniPDPCloseButtonAriaLabel[lang];

		obj.zoe = obj.zoe || {};
		obj.zoe.closeButtonAriaLabel = additionalTranslations.zoeCloseButtonAriaLabel[lang];

		obj.comparison = obj.comparison || {};
		obj.comparison.removeAriaLabel = additionalTranslations.removeAriaLabel[lang];
		obj.comparison.regionAriaLabel = additionalTranslations.regionAriaLabel[lang];
	}
});

export default res;